import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "nav.home": "Home",
      "nav.features": "Features",
      "nav.services": "Services",
      "nav.memorandums": "Legal Memorandums",
      "nav.pleadings": "Pleadings",
      "nav.legalDiscussion": "Legal Discussion",
      "nav.contactUs": "Contact Us",
      "nav.contact": "Contact Us",
      "nav.tools": "Tools",
      "nav.firmArchive": "Case archive",
      "navGroups.workspace": "Legal workspace",
      "navGroups.products": "DimoY products",
      "navGroups.general": "General",
      "nav.pricing": "Pricing",
      "nav.login": "Sign In",
      "nav.getStarted": "Get Started",
      "brand.name": "YimnakAI",
      "header.onlineNow": "Online now",
      "header.offline": "Offline",
      "header.guestBadge": "Guest",
      "hero.title": "From your first legal question to complete office management",
      "hero.descriptionLine1": "Save hours preparing legal briefs",
      "hero.descriptionLine2": "Know your legal position in minutes",
      "hero.descriptionLine3": "Manage your entire office from one place",
      "hero.subtitle": "From your first legal question to complete office management — save time on briefs, know your position, and run your office from one place.",
      "hero.cta": "Get Started",
      "hero.login": "Sign In",
      "landingQuestion.placeholder": "Ask your legal question here…",
      "landingQuestion.submit": "Ask now",
      "landingQuestion.emptyError": "Please enter your question before submitting.",
      "landingQuestion.helper": "Get an AI-guided legal answer — sign in later for the full response.",
      "hero.mockup.badge": "Smart legal consultation",
      "hero.mockup.questionLabel": "Question",
      "hero.mockup.questionText": "Can an employer terminate an employee's contract without prior notice in case of repeated absence?",
      "hero.mockup.answerLabel": "YimnakAI",
      "hero.mockup.answerText": "It depends on the nature of the absence and the applicable regulatory framework. If repeated absence without valid excuse is established in accordance with the regulations, the employer may be entitled to terminate the contract in accordance with the applicable procedures.",
      "hero.mockup.refsTitle": "Legal reference",
      "hero.mockup.ref1": "Saudi Labor Law",
      "hero.mockup.ref2": "Contract termination provisions",
      "hero.mockup.ref3": "Absence and discipline rules",
      "hero.mockup.footer": "Analysis based on Saudi regulations",
      "trust.title": "Trusted by legal teams and professional firms",
      "trust.lawFirms": "Law firms",
      "trust.legalDepts": "Legal departments",
      "trust.compliance": "Compliance teams",
      "trust.enterprises": "Enterprises",
      "features.title": "Everything you need for modern legal work",
      "features.subtitle": "Powerful tools designed for lawyers, in-house counsel, and compliance teams.",
      "feature.memorandums": "Legal Memorandums",
      "feature.memorandums.desc": "Draft and structure legal memorandums with AI assistance, aligned with Saudi regulations.",
      "feature.contracts": "Contract Analysis",
      "feature.contracts.desc": "Analyze contracts, identify risks, and get clear recommendations.",
      "feature.research": "Legal Research",
      "feature.research.desc": "Fast, cited answers to complex Saudi legal questions.",
      "feature.summary": "Document Summarization",
      "feature.summary.desc": "Summarize long documents and extract key legal points.",
      "feature.litigation": "Litigation Support",
      "feature.litigation.desc": "Support for pleadings, case analysis, and court preparation.",
      "feature.knowledge": "Legal Knowledge Base",
      "feature.knowledge.desc": "Organize and search your legal knowledge in one place.",
      "feature.review": "Review & Drafting",
      "feature.review.desc": "Review and refine legal text with AI-powered suggestions.",
      "feature.bilingual": "Bilingual Legal Assistant",
      "feature.bilingual.desc": "Full support in Arabic and English for Saudi and international work.",
      "usecases.title": "How it works",
      "usecases.subtitle": "From your question to a ready legal output in three steps.",
      "usecases.step1": "Upload your document or ask your question",
      "usecases.step2": "The system analyzes facts and legal context",
      "usecases.step3": "Get a draft, analysis, or actionable recommendation",
      "testimonials.title": "What legal teams say",
      "testimonials.subtitle": "Representative feedback from professionals using the platform.",
      "testimonial1.quote": "The platform helped us speed up legal memo drafting and keep our responses consistent.",
      "testimonial1.role": "Legal team",
      "testimonial2.quote": "We use it for contract review and research—it saves time and improves our workflow.",
      "testimonial2.role": "In-house counsel",
      "testimonial3.quote": "Clear, cited answers that we can rely on for Saudi law questions.",
      "testimonial3.role": "Compliance team",
      "metrics.memorandums": "Faster memo drafting",
      "metrics.access": "Better access to legal information",
      "metrics.teams": "Support for legal teams",
      "cta.title": "Start working smarter with legal AI",
      "cta.subtitle": "Create your account and get access to memorandums, research, and litigation support.",
      "cta.register": "Create account",
      "cta.login": "Sign In",
      "chat.title": "Turn your legal problem into a clear, systematic procedure in minutes.",
      "chat.subtitle": "Describe your legal issue, and Yimnak will analyze it under Saudi law, warn you of potential risks, and recommend the proper legal action with a ready document when needed.",
      "tools.title": "Seamless Integration",
      "tools.subtitle": "Connects with your favorite tools to automate your legal workflow.",
      "tools.page.title": "Legal Tools",
      "tools.page.subtitle": "Practical legal tools integrated into Ydim with the same native experience and a clean, scalable design.",
      "tools.page.switcherAriaLabel": "Legal tools switcher",
      "tools.common.currency.sar": "{{amount}} SAR",
      "tools.roadmap.title": "Future Readiness",
      "tools.roadmap.feature.reply-letter-generator": "Reply / response letter generator",
      "tools.roadmap.feature.firm-mode-prefill": "Firm mode prefill",
      "tools.roadmap.feature.office-templates": "Office templates",
      "tools.roadmap.feature.subscription-gating": "Subscription gating",
      "tools.eos.title": "End of Service Calculator",
      "tools.eos.subtitle": "Initial estimate for end-of-service award based on standard rules that can be extended later.",
      "tools.eos.field.monthlySalary": "Monthly salary (SAR)",
      "tools.eos.field.startDate": "Employment start date",
      "tools.eos.field.endDate": "Employment end date",
      "tools.eos.field.terminationType": "Termination reason",
      "tools.eos.field.contractType": "Contract type",
      "tools.eos.placeholder.monthlySalary": "Example: 8000",
      "tools.eos.option.termination.employer": "Employer termination",
      "tools.eos.option.termination.resignation": "Resignation",
      "tools.eos.option.termination.contractEnd": "Contract end",
      "tools.eos.option.contract.unlimited": "Unlimited term",
      "tools.eos.option.contract.fixed": "Fixed term",
      "tools.eos.validation.invalidInput": "Unable to calculate due to missing or invalid inputs.",
      "tools.eos.result.estimatedAmount": "Estimated amount",
      "tools.eos.result.explanation": "Estimated service period is {{serviceYears}} years based on monthly salary {{salary}} SAR.",
      "tools.eos.result.assumptionsHeading": "Calculation assumptions",
      "tools.eos.result.notesHeading": "Important note",
      "tools.eos.assumption.validSalary": "Please enter a valid monthly salary.",
      "tools.eos.assumption.validDates": "Employment end date must be after start date.",
      "tools.eos.assumption.saudiRule": "The estimate follows common simplified rules in Saudi labor practice.",
      "tools.eos.assumption.exclusions": "This estimate does not include allowances, exceptional cases, or private settlements.",
      "tools.eos.assumption.contract.fixed": "Selected contract type: Fixed term.",
      "tools.eos.assumption.contract.unlimited": "Selected contract type: Unlimited term.",
      "tools.eos.multiplier.employerOrContractEnd": "Employer termination or contract end: full estimated entitlement.",
      "tools.eos.multiplier.resignation.lt2": "Resignation before completing 2 years: no estimated end-of-service award.",
      "tools.eos.multiplier.resignation.2to5": "Resignation after 2 years and before 5 years: one-third of the estimated entitlement.",
      "tools.eos.multiplier.resignation.5to10": "Resignation after 5 years and before 10 years: two-thirds of the estimated entitlement.",
      "tools.eos.multiplier.resignation.gte10": "Resignation after 10 years or more: full estimated entitlement.",
      "tools.eos.note.preliminary": "Result is for initial estimation only.",
      "tools.eos.note.consultLawyer": "Please consult a qualified lawyer before taking any final legal action.",
      "tools.demand.title": "Demand Letter Generator",
      "tools.demand.subtitle": "Professional Arabic template ready for copy and print, based on a clear legal format.",
      "tools.demand.field.creditorName": "Creditor / claimant name",
      "tools.demand.field.debtorName": "Debtor name",
      "tools.demand.field.amount": "Claim amount (SAR)",
      "tools.demand.field.claimBasis": "Claim basis",
      "tools.demand.field.dueDate": "Due date (optional)",
      "tools.demand.field.paymentPeriodDays": "Or payment period (days)",
      "tools.demand.field.notes": "Additional notes (optional)",
      "tools.demand.placeholder.creditorName": "Example: Ahmed Al-Qahtani",
      "tools.demand.placeholder.debtorName": "Example: XYZ Company",
      "tools.demand.placeholder.amount": "Example: 25000",
      "tools.demand.placeholder.claimBasis": "Example: Outstanding service contract dues",
      "tools.demand.placeholder.paymentPeriodDays": "Example: 7",
      "tools.demand.placeholder.notes": "Any additional details you want to include in the letter",
      "tools.demand.result.finalText": "Final text (copyable and print-friendly)",
      "tools.demand.action.copy": "Copy letter",
      "tools.demand.action.copied": "Copied",
      "tools.demand.action.print": "Print",
      "login.title": "Welcome Back",
      "login.email": "Email Address",
      "login.password": "Password",
      "login.submit": "Sign In",
      "footer.rights": "© 2025 LegalAgent. All rights reserved.",
      "footer.product": "Product",
      "footer.company": "Company",
      "footer.about": "About",
      "footer.blog": "Blog",
      "footer.contact": "Contact",
      "footer.privacy": "Privacy Policy",
      "footer.terms": "Terms of Service",
      
      // Merged from LanguageContext
      "home": "Home",
      "contact": "Legal discussion",
      "chat": "Memorandum",
      "Memorandum": "Legal memoranda and regulations",
      "logout": "Logout",
      "pleadings": "Pleadings",
      "welcomeTitle": "Welcome to Yemnnak",
      "welcomeSubtitle": "Use legal AI with integrated chat capabilities and trusted review.",
      "realTimeChat": "Legal discussion",
      "realTimeChatDesc": "Get instant, AI-powered legal answers based on Saudi laws and regulations.",
      "pleadingsDesc": "Analyze legal judgments and pleadings systematically, uncovering systemic flaws and procedural issues.",
      "ourServices": "Our Services",
      "ourServicesDesc": "Explore our comprehensive range of professional services.",
      "analytics": "Legal Memorandum Generator",
      "analyticsDesc": "Preparing legal memoranda through artificial intelligence, in full compliance with Saudi regulations, including guidance on submission procedures and evaluation of legal position strength..",
      "contactSupport": "Legal discussion",
      "contactSubtitle": "We're here to help! Send us a message and we'll get back to you.",
      "typeMessage": "Type your message here...",
      "send": "Send",
      "you": "You",
      "bot": "Bot",
      "welcomeMessage": "Hello! How can I help you today?",
      "errorMessage": "⚠️ Sorry, there was a problem connecting to the server.",
      "newChat": "New Chat",
      "copyMessage": "Copy message",
      "likeMessage": "Like message",
      "dislikeMessage": "Dislike message",
      "shareMessage": "Share message",
      "scrollToBottom": "Scroll to bottom",
      "ourServicesTitle": "Our Services",
      "ourServicesSubtitle": "Professional legal services tailored to meet your business needs",
      "legalConsultations": "Legal Consultations",
      "legalConsultationsDesc": "Professional legal advice and consultation services",
      "contractDrafting": "Contract Drafting",
      "contractDraftingDesc": "Custom contract drafting tailored to your specific needs",
      "contractReview": "Contract Review",
      "contractReviewDesc": "Thorough review and analysis of existing contracts",
      "legalMemorandums": "Legal Memorandums Writing",
      "legalMemorandumsDesc": "Professional legal memorandum writing services",
      "allRightsReserved": "All rights reserved.",
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",
      "chat.instructions.general": "Describe your legal issue, and Yimnak will analyze it under Saudi law, warn you of potential risks, and recommend the proper legal action.",
      "chat.instructions.memorandum": "Please provide a clear summary of the dispute or issue, including key facts only, without sensitive data or explicit names, to enable accurate preparation of a legal memorandum.",
      "chat.instructions.pleadings": "Please enter the text of the pleading or judgment to be analyzed in terms of legal risks, procedural gaps, and judicial outcome.",
      "journey.contact": "Understanding the issue → Legal analysis → Risk alerts → Recommended legal action",
      "journey.chat": "Issue summary → Legal qualification → Drafting memorandum → Final legal document",
      "journey.pleadings": "Reading judgment → Procedural analysis → Legal gaps → Judicial outcome",


      
      // Privacy Policy
      "privacyPolicy.title": "Privacy Policy",
      "privacyPolicy.subtitle": "Yimnak (Ydim) — how we handle personal data, documents, and AI-assisted workflows.",
      "privacyPolicy.introduction.title": "Introduction",
      "privacyPolicy.introduction.body": "Yimnak (Ydim) is a Saudi technology platform that supports legal workflows with AI, document analysis, and tools for individuals, organizations, and law firms. This policy explains what we collect, how we use it, and the choices available to you. We process data in line with applicable laws in the Kingdom of Saudi Arabia, including the Personal Data Protection Law (PDPL).",
      "privacyPolicy.serviceNature.title": "Nature of the service",
      "privacyPolicy.serviceNature.body": "Ydim provides software and digital tools to organize work, analyze text and documents, and support professional judgment. Yimnak is not a law firm, does not act as your attorney, and does not provide binding legal advice. Outputs are informational and operational aids; qualified professionals remain responsible for decisions and filings.",
      "privacyPolicy.aiUse.title": "Use of artificial intelligence",
      "privacyPolicy.aiUse.body": "Some features use AI models to summarize content, highlight risks, draft text, or suggest next steps. AI results can be incomplete or wrong and must be reviewed by a qualified person before you rely on them. We may use trusted external providers for hosting, inference, or security controls under contractual safeguards; we do not use your content to train public models unless we tell you clearly and you agree.",
      "privacyPolicy.documents.title": "Files and documents",
      "privacyPolicy.documents.description": "When you upload files or enter case-related data, we process them to deliver the feature you requested. This may include:",
      "privacyPolicy.documents.item1": "Account identifiers, contact details, and workspace or firm context you provide.",
      "privacyPolicy.documents.item2": "Document content, metadata, and analysis outputs (including chat, memoranda, pleadings, and contract review).",
      "privacyPolicy.documents.item3": "Technical logs needed for security, abuse prevention, billing, and service quality.",
      "privacyPolicy.documents.item4": "Masked or minimized text where privacy controls apply before downstream processing.",
      "privacyPolicy.firmMode.title": "Firm Mode and office workspaces",
      "privacyPolicy.firmMode.body": "Firm Mode is designed for law firms and professional teams. Data for each office or workspace is logically separated and access is limited to authorized users in that workspace. Firm administrators manage membership; we do not merge one firm's matters with another's without a clear legal basis and your instructions.",
      "privacyPolicy.pdpl.title": "Data protection and PDPL",
      "privacyPolicy.pdpl.body": "We apply administrative, technical, and organizational measures suited to the sensitivity of legal and business data. These include access control, encryption in transit where supported, monitoring, and retention limits. You may request access, correction, or deletion of personal data where PDPL and our records allow. We respond to lawful requests from competent authorities when required.",
      "privacyPolicy.liability.title": "Limitation of responsibility",
      "privacyPolicy.liability.body": "The platform is provided as a professional tool. To the extent permitted by law, Yimnak is not liable for losses arising from uncorrected AI output, user misconfiguration, or use contrary to this policy. Nothing here limits mandatory consumer rights or liability that cannot be excluded under Saudi law.",
      "privacyPolicy.prohibitedUse.title": "Prohibited use",
      "privacyPolicy.prohibitedUse.description": "You must not use Ydim to:",
      "privacyPolicy.prohibitedUse.item1": "Upload unlawful content or material you are not authorized to share.",
      "privacyPolicy.prohibitedUse.item2": "Attempt to bypass security, tenant isolation, or access another customer's data.",
      "privacyPolicy.prohibitedUse.item3": "Use the service as a substitute for regulated legal representation without independent professional review.",
      "privacyPolicy.prohibitedUse.item4": "Scrape, resell, or reverse engineer the service except as allowed in your agreement with us.",
      "privacyPolicy.retention.title": "Data retention",
      "privacyPolicy.retention.body": "We keep personal data and workspace content only as long as needed for the service, billing, security, and legal obligations, then delete or anonymize it according to our schedules and your settings where available. Backups may persist for a limited period before rotation.",
      "privacyPolicy.cookies.title": "Cookies and similar technologies",
      "privacyPolicy.cookies.body": "We use cookies and local storage for sign-in sessions, preferences, analytics, and security. You can control browser cookies; disabling some cookies may limit parts of the site. We do not use cookies to sell personal data.",
      "privacyPolicy.contact.title": "Contact",
      "privacyPolicy.contact.body": "For privacy questions, PDPL requests, or security reports, contact us through the channels published on the Yimnak website or in-product support. We will verify your identity before changing account data.",
      "privacyPolicy.consent.title": "Your agreement",
      "privacyPolicy.consent.description": "By creating an account or continuing to use Ydim, you confirm that you have read this policy and agree to our processing as described. If you do not agree, please stop using the service.",
      
      // Registration Privacy Policy Agreement
      "register.privacyAgreement": "I agree to the Privacy Policy",
      "register.privacyAgreementError": "You must agree to the Privacy Policy before registering",
      
      // Pricing
      "pricing.title": "Pricing",
      "pricing.subtitle": "Choose the plan that's right for you",
      "pricing.recommended": "Recommended",
      "pricing.billingInterval.label": "Billing interval",
      "pricing.billingInterval.monthly": "Monthly",
      "pricing.billingInterval.annual": "Annual",
      "pricing.checkoutReturn.confirming": "Payment received. We are confirming your subscription. This may take a moment.",
      "pricing.checkoutReturn.failed": "Payment was not completed.",
      "pricing.checkoutReturn.checking": "Payment status is being checked.",
      "pricing.checkoutReturn.active": "Your subscription is now active.",
      "pricing.checkoutReturn.pending": "Payment received, but subscription activation is still pending. Please refresh shortly or contact support.",
      "pricing.free.name": "Free",
      "pricing.free.price": "Free",
      "pricing.free.description": "Perfect for getting started",
      "pricing.free.feature1": "Basic legal consultations",
      "pricing.free.feature2": "Limited chat messages",
      "pricing.free.feature3": "Standard response time",
      "pricing.free.feature4": "Community support",
      "pricing.free.button": "Get Started",
      "pricing.pro.name": "Pro",
      "pricing.pro.price": "99 SAR/month",
      "pricing.pro.description": "For professionals and businesses",
      "pricing.pro.feature1": "Unlimited legal consultations",
      "pricing.pro.feature2": "Unlimited chat messages",
      "pricing.pro.feature3": "Priority support",
      "pricing.pro.feature4": "Advanced AI features",
      "pricing.pro.feature5": "Document analysis",
      "pricing.pro.button": "Upgrade Now",
      "pricing.office.name": "Office",
      "pricing.office.description": "For legal firms and office teams",
      "pricing.office.feature1": "Everything in Pro",
      "pricing.office.feature2": "Office workspace",
      "pricing.office.feature3": "Office case management",
      "pricing.office.feature4": "Higher team capacity",
      "pricing.office.feature5": "Priority support",
      "pricing.office.button": "Upgrade Now",
      "pricing.enterprise.name": "Enterprise",
      "pricing.enterprise.price": "Contact us",
      "pricing.enterprise.description": "For large organizations",
      "pricing.enterprise.feature1": "Everything in Pro",
      "pricing.enterprise.feature2": "Dedicated account manager",
      "pricing.enterprise.feature3": "Custom integrations",
      "pricing.enterprise.feature4": "SLA guarantees",
      "pricing.enterprise.feature5": "On-premise deployment options",
      "pricing.enterprise.button": "Contact Us",
      "upgrade.title": "Upgrade Plan",
      "upgrade.confirmWithBilling": "Are you sure you want to upgrade to {{planId}} ({{billingInterval}} billing)?",
      "upgrade.billingIntervalNote": "You will be charged the selected billing interval price at checkout.",
      "upgrade.trialNote": "This upgrade will be applied as a trial. No payment required.",
      "upgrade.continueToPayment": "Continue to Payment",
      "upgrade.checkoutFailed": "Failed to prepare checkout.",
      "upgrade.cancel": "Cancel",
      "upgrade.processing": "Processing...",
      "systemPortal.title": "Integrated Systems Portal",
      "systemPortal.subtitle": "Fast, structured access to the connected platforms — the Yimnak assistant, the Arsheef office platform, and the Legal Ingestion regulations platform — in one place with a cohesive experience.",
      "cards.yimnak.title": "Yimnak",
      "cards.yimnak.subtitle": "",
      "cards.yimnak.description": "The smart legal assistant — for users and anyone interested: ask questions and get guidance in clear language, with respect for privacy and the limits of legal consultation.",
      "cards.yimnak.cta": "Enter Ydim",
      "cards.arsheef.title": "Arsheef",
      "cards.arsheef.subtitle": "",
      "cards.arsheef.description": "For law firms and lawyers: manage cases, clients, and tasks from a single platform built for the legal workplace.",
      "cards.arsheef.cta": "Legal offices login",
      "cards.systems.title": "Systems",
      "cards.systems.subtitle": "Legal Ingestion",
      "cards.systems.description": "Regulations, laws, and legal ingestion — browse texts, articles, and amendments in a structured way.",
      "cards.systems.cta": "Go to the systems platform",
      "cards.legalIntelligence.title": "Legal Intelligence Engine",
      "cards.legalIntelligence.subtitle": "",
      "cards.legalIntelligence.description": "Automatic analysis of your organization's contracts and documents, risk detection, and tracking of regulatory obligations.",
      "cards.legalIntelligence.cta": "Enter Legal Intelligence Engine",
      "quickAccess.home": "Home",
      "quickAccess.systems": "Systems",
      "quickAccess.officeLogin": "Office login",
      "quickAccess.platform": "Regulations platform",
      "quickAccess.contact": "Contact us",
      "appLauncher.title": "Projects",
      "appLauncher.openMenu": "Open projects menu",
      "appLauncher.closeMenu": "Close projects menu",
      "appLauncher.ydim": "Yimnak",
      "appLauncher.arsheef": "Case Management",
      "appLauncher.ingestion": "Laws & Regulations",
      "appLauncher.legalIntelligence": "AI-Contract Review",
      "appLauncher.ydimDesc": "Smart legal assistant for questions and guidance.",
      "appLauncher.arsheefDesc": "Manage cases, clients, and firm workflows in one place.",
      "appLauncher.ingestionDesc": "Browse laws, regulations, and structured legal articles.",
      "appLauncher.legalDesc": "AI-powered contract review, risk detection, and compliance tracking.",
      "contactForm.title": "Contact Us",
      "contactForm.subtitle": "We’d love to hear from you",
      "contactForm.name": "Full name",
      "contactForm.email": "Email",
      "contactForm.subject": "Subject",
      "contactForm.message": "Message",
      "contactForm.submit": "Send message",
      "contactForm.sending": "Sending…",
      "contactForm.success": "Your message was sent. We’ll get back to you soon.",
      "contactForm.error.required": "Please fill in all required fields.",
      "contactForm.error.messageLength": "Message is too long.",
      "contactForm.error.generic": "Could not send your message. Please try again later.",
      "contactForm.error.notConfigured": "The contact service is not configured on the server. Please try email directly.",
      "contactForm.error.rateLimit": "Too many attempts. Please try again later.",
      "contactForm.infoTitle": "Email us",
      "contactForm.infoNote": "We aim to respond within 1–2 business days.",
      "contactForm.subject.enterprise": "Enterprise / custom plan inquiry",

      "adminPage.title": "Admin dashboard",
      "adminPage.subtitle": "Legal chat analytics and activity monitoring",
      "adminPage.loading": "Loading dashboard…",
      "adminPage.platformTitle": "Platform metrics",
      "adminPage.platformDesc": "Users, visitors, and chat activity at a glance.",
      "adminPage.interactionsTitle": "Recent interactions",
      "adminPage.interactionsDesc": "Latest chat questions and answers. Click a row to open full details.",
      "adminPage.emptyInteractions": "No data available at the moment",
      "adminPage.guest": "Guest",
      "adminPage.prev": "Previous",
      "adminPage.next": "Next",
      "adminPage.pageInfo": "Page {{current}} of {{total}}",
      "adminPage.colDate": "Date / time",
      "adminPage.colSession": "Session",
      "adminPage.colUser": "User",
      "adminPage.colSource": "Source",
      "adminPage.colQuestion": "Question",
      "adminPage.colAnswer": "Answer",
      "adminPage.modalTitle": "Interaction details",
      "adminPage.close": "Close",
      "adminPage.labelDate": "Date / time",
      "adminPage.labelSession": "Session ID",
      "adminPage.labelUser": "User ID",
      "adminPage.labelSource": "Source page",
      "adminPage.labelQuestion": "Question",
      "adminPage.labelAnswer": "Answer",
      "adminPage.scrollRegion": "More rows",

      "adminPage.metricTotalUsers": "Total users (unique)",
      "adminPage.metricRegistered": "Registered users",
      "adminPage.metricVisitors": "Total visitors (unique sessions)",
      "adminPage.metricVisits": "Total visits (page loads)",
      "adminPage.metricInteractions": "Total interactions",
      "adminPage.metricToday": "Today’s interactions",
      "adminPage.metric24h": "Last 24 hours",

      "adminHub.shellTitle": "Operating control",
      "adminHub.shellSubtitle": "Commercial & operational visibility (read-only). Sprint 3.3 — structured admin hub; no payments or enforcement.",
      "adminHub.sidebarAria": "Admin sections",
      "adminHub.navOverview": "Overview",
      "adminHub.navLegacyDashboard": "Legacy dashboard",
      "adminHub.navCommercial": "Commercial",
      "adminHub.navPlans": "Plans catalog",
      "adminHub.navEntitlements": "Entitlements preview",
      "adminHub.navGuestPolicies": "Guest policies",
      "adminHub.navFirmMode": "Firm Mode preview",
      "adminHub.navAiUsagePolicies": "AI usage policies",
      "adminHub.navOperations": "Operations",
      "adminHub.navAiVisibility": "AI & usage visibility",
      "adminHub.navOperationalHealth": "Operational health",
      "adminHub.navAsyncJobs": "Async jobs readiness",
      "adminHub.navOrganizations": "Organizations",
      "adminHub.navOfficesConsumption": "Offices & consumption",
      "adminHub.navPlatform": "Platform",
      "adminHub.navFeatureFlags": "Feature flags & billing",
      "adminHub.navServiceReadiness": "Service readiness",
      "adminHub.navObservability": "Observability & analytics",
      "adminHub.observabilityTitle": "Observability & analytics",
      "adminHub.observabilityDesc": "In-process Ydim metrics and local health probes for internal services (read-only).",
      "adminHub.capPlatformObservability": "Service health and request metrics for operators.",
      "adminObs.refreshData": "Refresh data",
      "adminObs.lastUpdated": "Last updated",
      "adminObs.metricsDisabled": "Observability is not enabled. Set ENABLE_METRICS=true in the runtime environment.",
      "adminObs.loadError": "Could not load observability data right now.",
      "adminObs.accessDenied": "Admin access is required to view observability.",
      "adminObs.sectionYdim": "Ydim",
      "adminObs.sectionServices": "Internal services",
      "adminObs.cardYdimStatus": "Ydim status",
      "adminObs.cardRequestsTotal": "Total requests",
      "adminObs.cardResponseAvg": "Average response time",
      "adminObs.cardErrors4xx": "4xx errors",
      "adminObs.cardErrors5xx": "5xx errors",
      "adminObs.cardSentry": "Sentry status",
      "adminObs.cardPrivacyGateway": "Privacy Gateway",
      "adminObs.cardLie": "Legal Intelligence Engine",
      "adminObs.cardIngestion": "Ingestion",
      "adminObs.statusAvailable": "Available",
      "adminObs.statusUnknown": "Unknown",
      "adminObs.statusUnavailable": "Unavailable",
      "adminObs.sentryOn": "Configured",
      "adminObs.sentryOff": "Not configured",
      "adminObs.errorsByRouteTitle": "Errors by route",
      "adminObs.errorsByRouteEmpty": "No 4xx or 5xx route responses recorded yet.",
      "adminObs.colStatus": "Status",
      "adminObs.colMethod": "Method",
      "adminObs.colPath": "Path",
      "adminObs.colCount": "Count",
      "adminHub.loadError": "Could not load this section. Check admin session and server logs.",
      "adminHub.loadAction": "Load / refresh",
      "adminHub.userIdLabel": "Ydim user id",
      "adminHub.planCode": "Plan code",
      "adminHub.userKeyOptional": "Usage user_key (optional)",
      "adminHub.dateFrom": "From (UTC date)",
      "adminHub.dateTo": "To (UTC date)",
      "adminHub.officeIdOptional": "Office id filter (optional)",
      "adminHub.officePlanCode": "Office plan code (optional)",
      "adminHub.asyncLimit": "Recent jobs limit",
      "adminHub.asyncSummaryHeading": "Async summary",
      "adminHub.asyncRecentHeading": "Recent platform_async_jobs",
      "adminHub.firmPreviewGuest": "Treat as guest",
      "adminHub.firmPreviewJwt": "Simulate Firm JWT present",
      "adminHub.aiAllowanceNote": "Leave user_key empty for allowance-only preview; set user_key + dates to compare rollups (soft preview).",
      "adminHub.commercialPlansTitle": "Plans catalog",
      "adminHub.commercialPlansDesc": "Plan catalog from billing_plans merged with fallbacks — table view + optional JSON (read-only).",
      "adminHub.entitlementsTitle": "Entitlements preview",
      "adminHub.entitlementsDesc": "Per-user effective plan and legacy usage.js quotas — cards, table, optional JSON.",
      "adminHub.guestPoliciesTitle": "Guest policies",
      "adminHub.guestPoliciesDesc": "Guest limits and commercial policy — matrices + optional JSON (no new enforcement).",
      "adminHub.firmModeTitle": "Firm Mode entitlement preview",
      "adminHub.firmModeDesc": "Scenario preview — structured cards; live Firm behavior unchanged.",
      "adminHub.aiUsagePoliciesTitle": "AI allowance preview",
      "adminHub.aiUsagePoliciesDesc": "AI allowance vs rollups — metric cards + optional JSON (monitoring only).",
      "adminHub.aiVisibilityTitle": "AI & operational bundle",
      "adminHub.aiVisibilityDesc": "Operational bundle — window, health, heuristics, tables, collapsible raw JSON.",
      "adminHub.opHealthTitle": "Operational health",
      "adminHub.opHealthDesc": "Windowed health — metric cards + heuristics + optional JSON.",
      "adminHub.asyncJobsTitle": "Async jobs",
      "adminHub.asyncJobsDesc": "platform_async_jobs — summary, status table, recent jobs + optional JSON (no worker controls).",
      "adminHub.orgOfficesTitle": "Offices & consumption",
      "adminHub.orgOfficesDesc": "Office AI consumption — table + optional JSON (Arsheef RBAC unchanged).",
      "adminHub.flagsTitle": "Feature flags & descriptors",
      "adminHub.authLoginTitle": "Auth & OTP login",
      "adminHub.authLoginDesc": "OTP provider and password login visibility. Secrets remain in environment variables only.",
      "adminHub.navAuthLogin": "Auth & OTP login",
      "adminHub.flagsDesc": "Billing flags with descriptors — table + optional JSON (read-only).",
      "adminHub.readinessTitle": "Integration readiness",
      "adminHub.readinessDesc": "Env presence hints — badge grid + optional JSON (no secrets, no probes).",
      "adminHub.capOverview": "Original analytics dashboard (interactions, Ydim/Ingestion/LIE cards).",
      "adminHub.capCommercialPlans": "Plan catalog snapshot for commercial alignment.",
      "adminHub.capCommercialEntitlements": "Per-user effective plan preview.",
      "adminHub.capCommercialGuest": "Guest policy documentation + catalog limits.",
      "adminHub.capCommercialFirm": "Firm entitlement scenario preview.",
      "adminHub.capCommercialAi": "AI allowance vs rollups preview.",
      "adminHub.capOpsInsights": "Full operational insights bundle.",
      "adminHub.capOpsHealth": "Operational health subset.",
      "adminHub.capOpsAsync": "Async job registry visibility.",
      "adminHub.capOrgOffices": "Office consumption from Ydim-side rollups.",
      "adminHub.capPlatformFlags": "Billing flags + descriptors.",
      "adminHub.capPlatformAuthLogin": "OTP provider + password login toggle.",
      "adminHub.capPlatformReadiness": "Cross-service env readiness hints.",
      "adminHub.navEnforcementReadiness": "Enforcement bridge",
      "adminHub.enforcementTitle": "Plan enforcement bridge",
      "adminHub.enforcementDesc": "Enforcement bridge — mode, shadow stats, env & billing flags + optional JSON (no production enforcement).",
      "adminHub.capCommercialEnforcement": "Observability for plan-resolver bridge and mismatch counters.",

      "adminKit.tableEmpty": "No rows to display.",
      "adminKit.rawJsonToggle": "Raw JSON (advanced)",
      "adminKit.rawBundleJson": "Full response JSON (advanced)",
      "adminKit.planCatalogTableTitle": "Active plan catalog",
      "adminKit.planCatalogTableSub": "Merged DB row + fallback catalog per plan code.",
      "adminKit.colPlanCode": "plan_code",
      "adminKit.colAudience": "audience_type",
      "adminKit.colMonthly": "monthly_price",
      "adminKit.colAnnual": "annual_price",
      "adminKit.colCurrency": "currency",
      "adminKit.colActive": "source / active",
      "adminKit.colLimitsSummary": "limits (quotas summary)",
      "adminKit.colAiSummary": "AI limits summary",
      "adminKit.colFirmHint": "firm_mode (limits/features)",
      "adminKit.colMetadataPreview": "catalog_metadata (preview)",
      "adminKit.enforcementRuntimeTitle": "Runtime resolution",
      "adminKit.enforcementRuntimeSub": "HTTP allow/deny remains legacy; this panel is observability only.",
      "adminKit.metricResolverBridge": "Resolver bridge enabled",
      "adminKit.metricResolverBridgeHint": "Env OR billing flag plan_limits_resolver_paywall.",
      "adminKit.metricEnforcementMode": "Effective mode",
      "adminKit.metricEnforcementModeHint": "off | shadow | soft | enforce_later (enforce_later is not active in production).",
      "adminKit.metricLegacySource": "Legacy enforcement source",
      "adminKit.metricLegacySourceHint": "Authoritative for 403 today.",
      "adminKit.metricResolverSource": "Resolver source",
      "adminKit.metricResolverSourceHint": "Catalog mirror for comparison / preview.",
      "adminKit.shadowStatsTitle": "Shadow comparison counters",
      "adminKit.metricMismatchCount": "legacy vs resolver mismatches",
      "adminKit.metricMismatchHint": "In-process since last server restart.",
      "adminKit.metricGuestHints": "guest soft hints recorded",
      "adminKit.metricLastMismatch": "last mismatch at (UTC)",
      "adminKit.metricLastRoute": "last route label",
      "adminKit.envHintsTitle": "Environment overrides",
      "adminKit.systemBillingFlagsTitle": "Billing flags (subset)",
      "adminKit.colSetting": "Setting",
      "adminKit.colValue": "Value",
      "adminKit.yes": "Yes",
      "adminKit.no": "No",
      "adminKit.set": "set",
      "adminKit.unset": "unset",
      "adminKit.enforceLaterNotProduction": "enforce_later is reserved — production HTTP decisions still follow legacy in Sprint 3.2–3.3.",
      "adminKit.guestSummaryTitle": "Guest capability matrix (policy.limits)",
      "adminKit.guestSummarySub": "High-level guest posture from unified guest limits payload.",
      "adminKit.guestAreaChat": "Chat",
      "adminKit.guestChatDetail": "Guests get a limited chat experience per product policy.",
      "adminKit.guestLimited": "Limited",
      "adminKit.guestYes": "Yes",
      "adminKit.guestAreaDocuments": "Documents",
      "adminKit.guestDocDetail": "Upload is disabled for guests in product policy.",
      "adminKit.guestAreaFirm": "Firm Mode",
      "adminKit.guestFirmDetail": "Requires Arsheef JWT; guests do not receive it.",
      "adminKit.guestAreaArsheef": "Arsheef",
      "adminKit.guestArsheefDetail": "No guest login path on Arsheef.",
      "adminKit.guestAreaHeavyLie": "Heavy LIE analysis",
      "adminKit.guestLieDetail": "Heavy analysis is product-gated via Ydim.",
      "adminKit.guestPolicyDocTitle": "Commercial policy document (capabilities)",
      "adminKit.guestCatalogLimitsTitle": "Guest quotas & limits from catalog",
      "adminKit.guestEnforcementNote": "Enforcement field on API objects is informational here — live routes unchanged.",
      "adminKit.guestSoftGeneric": "Soft guest warning sample (document_upload).",
      "adminKit.colArea": "Area",
      "adminKit.colAllowed": "Allowed / posture",
      "adminKit.colDetail": "Detail",
      "adminKit.colCapability": "Capability",
      "adminKit.colNote": "Note",
      "adminKit.colResource": "Resource",
      "adminKit.colQuotaCatalog": "Quota (catalog)",
      "adminKit.colLimitCatalog": "Limit (catalog)",
      "adminKit.firmEntitlementTitle": "Firm entitlement preview",
      "adminKit.firmEntitlementSub": "Scenario inputs above — not live user state.",
      "adminKit.firmModeEnabled": "firm_mode_enabled",
      "adminKit.firmModeSource": "firm_mode_source",
      "adminKit.addonRequired": "addon_required",
      "adminKit.officePlanCodeLabel": "office_plan_code",
      "adminKit.billingStatus": "billing_status",
      "adminKit.enforcementMode": "enforcement",
      "adminKit.planCode": "plan_code",
      "adminKit.resolverSource": "resolver source",
      "adminKit.audienceType": "audience_type",
      "adminKit.officePlanResolvedTitle": "Office plan (resolver mirror)",
      "adminKit.firmTemporaryExemptionWarn": "Firm Mode paywall exemption may be active in live routes — treat as temporary until office billing alignment.",
      "adminKit.firmPreviewNoBehaviorChange": "Preview only — no change to live Firm routing.",
      "adminKit.aiAllowanceTitle": "AI allowance preview",
      "adminKit.aiAllowanceSub": "From plan catalog / metadata; optional rollup window when user_key is set.",
      "adminKit.aiUsedUnitsWindow": "usage_units (window)",
      "adminKit.aiRollupWindowHint": "Sum of user_usage_daily_rollups.usage_units_sum for the selected dates.",
      "adminKit.aiLimit": "limit (units)",
      "adminKit.aiUsed": "used (units)",
      "adminKit.aiRemaining": "remaining (units)",
      "adminKit.unlimited": "Unlimited",
      "adminKit.allowanceSource": "allowance source",
      "adminKit.aiWarningHint": "Soft preview warning from resolver (does not block LIE/chat).",
      "adminKit.aiTopTypesNote": "Per usage_type breakdown is available in Operations → AI visibility (rollups/events), not in this allowance endpoint.",
      "adminKit.entitlementUserTitle": "User context",
      "adminKit.entitlementUserSub": "Loaded from billing-access + resolver preview.",
      "adminKit.userId": "user id",
      "adminKit.planId": "plan id",
      "adminKit.accountKind": "account kind",
      "adminKit.resolverEnforcement": "resolver enforcement flag",
      "adminKit.resolvedPlanTitle": "Resolved plan (catalog merge)",
      "adminKit.perResourceQuotasTitle": "Per-resource quotas (usage.js engine)",
      "adminKit.colAllowedRaw": "allowed",
      "adminKit.colUsed": "used",
      "adminKit.colLimit": "limit",
      "adminKit.colRemaining": "remaining",
      "adminKit.colEngine": "engine",
      "adminKit.opsWindowTitle": "Selected window",
      "adminKit.opsWindowSub": "UTC date labels as sent to the API.",
      "adminKit.metricEventCount": "ai_usage_events (count)",
      "adminKit.metricUsageUnits": "usage_units_sum",
      "adminKit.metricGuestEvents": "guest-linked events",
      "adminKit.metricGuestUnits": "guest-linked units",
      "adminKit.opsHealthTotalsTitle": "Aggregate totals",
      "adminKit.opsHeuristicsTitle": "Heuristics (monitoring)",
      "adminKit.heurAiHealth": "ai_usage_health",
      "adminKit.heurOcrLoad": "ocr_load",
      "adminKit.heurLlmPressure": "llm_heavy_operations",
      "adminKit.heurFailedRatio": "failed_analysis_ratio",
      "adminKit.officePolicyPreviewTitle": "Office policy preview",
      "adminKit.officePolicyPreviewNote": "Shown when office_id filter is provided.",
      "adminKit.topAiUsageTitle": "Top AI usage by type",
      "adminKit.guestPressureTitle": "Guest pressure (top buckets)",
      "adminKit.officeConsumptionTitle": "Office AI consumption (top)",
      "adminKit.colSourceProject": "source_project",
      "adminKit.colUsageType": "usage_type",
      "adminKit.colUsageSubtype": "usage_subtype",
      "adminKit.colEvents": "events",
      "adminKit.colUnits": "usage_units",
      "adminKit.colGuestBucket": "guest_bucket",
      "adminKit.colOfficeId": "office_id",
      "adminKit.colDateFrom": "from",
      "adminKit.colDateTo": "to",
      "adminKit.asyncPending": "pending jobs",
      "adminKit.asyncRetryHeavy": "retry_count ≥ 3",
      "adminKit.asyncStuckThreshold": "stuck threshold (minutes)",
      "adminKit.asyncStuckSample": "stuck processing rows (sample size)",
      "adminKit.colJobStatus": "status",
      "adminKit.colCount": "count",
      "adminKit.colJobType": "job_type",
      "adminKit.colRetries": "retry_count",
      "adminKit.colUpdated": "updated_at",
      "adminKit.readinessGridTitle": "Environment hints",
      "adminKit.readinessGridSub": "Boolean presence only — values are never secret literals.",
      "adminKit.configured": "configured",
      "adminKit.missing": "missing / empty",
      "adminKit.flagsDescriptorTitle": "Billing flags & readiness metadata",
      "adminKit.flagsDescriptorSub": "Static labels from admin-settings-descriptor; values from system_settings.",
      "adminKit.colFlagKey": "flag key",
      "adminKit.colLabel": "descriptor label",
      "adminKit.colScope": "scope",
      "adminKit.colReadiness": "enforcement readiness",
      "adminKit.officeRowCount": "rows returned",

      "adminHub.navCommercialSnapshot": "Commercial snapshot",
      "adminHub.commercialSnapshotTitle": "Commercial & operations snapshot",
      "adminHub.commercialSnapshotDesc": "Aggregated read-only signals from existing admin APIs — safe CSV/JSON export; no payments, invoices, or hard enforcement controls.",
      "adminHub.capCommercialSnapshot": "One-page internal summary (plans, enforcement, guest, Firm preview, AI allowance, async pressure, readiness).",

      "adminExport.toolbarAria": "Table tools",
      "adminExport.search": "Search",
      "adminExport.searchPlaceholder": "Search visible columns…",
      "adminExport.filter": "Column filters",
      "adminExport.filterAll": "All",
      "adminExport.filterActiveLike": "Active (DB row)",
      "adminExport.filterInactive": "Inactive",
      "adminExport.filterCatalogFallback": "Catalog fallback",
      "adminExport.exportCsv": "Export CSV",
      "adminExport.exportJson": "Export JSON",
      "adminExport.resultCount": "{{filtered}} / {{total}} rows",
      "adminExport.resultCountSimple": "{{n}} rows",
      "adminExport.noResults": "No matching rows — adjust search or filters.",
      "adminExport.copy": "Copy",
      "adminExport.copyRow": "Copy row",
      "adminExport.copyJson": "Copy filtered JSON",
      "adminExport.compactMode": "Compact table",
      "adminExport.readinessConfigured": "Configured",
      "adminExport.readinessMissing": "Missing",
      "adminExport.aiPreviewTableTitle": "Allowance metrics (exportable)",

      "adminSnapshot.actionsTitle": "Refresh snapshot",
      "adminSnapshot.actionsSub": "Calls existing admin endpoints in parallel; nothing is stored on the server.",
      "adminSnapshot.summaryTitle": "At-a-glance",
      "adminSnapshot.summarySub": "High-signal fields only — details remain in section pages and raw JSON.",
      "adminSnapshot.tableTitle": "Flat metric keys",
      "adminSnapshot.colMetricKey": "Metric",
      "adminSnapshot.sourcesJson": "Endpoint reachability (boolean)",
      "adminSnapshot.promptLoad": "Use “Load / refresh” to build a snapshot from live admin APIs.",
      "adminSnapshot.cardActivePlans": "Active-like plans (catalog)",
      "adminSnapshot.cardGuestUpload": "Guest document upload (policy)",
      "adminSnapshot.cardGuestUploadHint": "Product policy — not a paywall toggle.",
      "adminSnapshot.cardFirmPreview": "Firm preview (guest / no JWT)",
      "adminSnapshot.cardAiPlan": "AI preview plan_code",
      "adminSnapshot.cardAsyncPending": "Async pending (summary)",
      "adminSnapshot.cardReadiness": "Readiness keys configured / total",
      "adminSnapshot.cardCommercialSyncFailed24h": "Office sync failures (24h, events)",
      "adminSnapshot.cardCommercialEventsRecent": "Recent commercial events (fetched)",
      "adminSnapshot.cardCommercialAutomation": "COMMERCIAL_SYNC_AUTOMATION_MODE",
      "adminSnapshot.cardStaleSyncHint": "Stale / unhappy process sync hint",
      "adminSnapshot.commercialOrchestrationJson": "Commercial orchestration (read-only)",
      "adminSnapshot.commercialEventsSample": "Recent commercial events (sample)",
      "adminSnapshot.shadowReadinessJson": "Shadow readiness bundle (Sprint 3.8, read-only)",
      "adminSnapshot.cardShadowReadiness": "Shadow readiness bundle loaded",
      "adminSnapshot.cardShadowStaleLevel": "Stale governance warning level",
      "adminSnapshot.cardShadowDlqScenarios": "DLQ scenario descriptors (count)",
      "adminSnapshot.cardShadowWebhookSlots": "Webhook provider slots (future)",

      "adminAnalytics.ydimBlurb": "Ydim product and marketing usage (Ydim database).",
      "adminAnalytics.title": "Ydim product analytics",
      "adminAnalytics.conversionRate": "Conversion rate (guest → signup/login)",
      "adminAnalytics.newRegistrations30d": "New registrations (30d)",
      "adminAnalytics.todayVisitors": "Today's visitors",
      "adminAnalytics.registeredUsers": "Registered users (accounts)",
      "adminAnalytics.guestVisitors": "Guest visitors (page views, guest)",
      "adminAnalytics.registeredSessions": "Registered sessions (page views, logged in)",
      "adminAnalytics.totalVisitors": "Total visitors (distinct sessions)",
      "adminAnalytics.totalPageViews": "Total page views",
      "adminAnalytics.pageRefreshes": "Page refreshes",
      "adminAnalytics.adminVisits": "Admin visits",
      "adminAnalytics.adminRefreshes": "Admin refreshes",
      "adminAnalytics.monthlyVisitors": "Monthly visitors",
      "adminAnalytics.dailyVisitors30d": "Daily visitors (30 days)",
      "adminAnalytics.devices": "Devices",
      "adminAnalytics.sources": "Sources",
      "adminAnalytics.topPages": "Top pages",
      "adminAnalytics.count": "Count",
      "adminAnalytics.device": "Device",
      "adminAnalytics.source": "Source",
      "adminAnalytics.views": "Views",
      "adminAnalytics.page": "Page",
      "adminAnalytics.recentEvents": "Recent events",
      "adminAnalytics.importantClicks": "Important clicks",
      "adminAnalytics.loading": "Loading analytics...",
      "adminAnalytics.failed": "Failed to load analytics",
      "adminAnalytics.noData": "No data",
      "adminAnalytics.desktop": "Desktop",
      "adminAnalytics.mobile": "Mobile",
      "adminAnalytics.tablet": "Tablet",
      "adminAnalytics.direct": "Direct",
      "adminAnalytics.external": "External",
      "adminAnalytics.google": "Google",
      "adminAnalytics.linkedin": "LinkedIn",
      "adminAnalytics.x": "X",
      "adminAnalytics.time": "Time",
      "adminAnalytics.type": "Type",
      "adminAnalytics.event": "Event",
      "adminAnalytics.guest": "Guest",
      "adminAnalytics.session": "Session",
      "adminAnalytics.yes": "Yes",
      "adminAnalytics.no": "No",
      "adminAnalytics.unknown": "Unknown",
      "adminAnalytics.dash": "—",
      "adminAnalytics.legalIntelligenceTitle": "Legal Intelligence Analytics",
      "adminAnalytics.legalIntelligenceBlurb": "Legal Intelligence Engine usage (legal_intelligence database; read-only summary).",
      "adminAnalytics.legalIntelligenceUnavailable": "Legal Intelligence analytics unavailable",
      "adminAnalytics.legalRegisteredUsers": "Registered users",
      "adminAnalytics.legalGuests": "Guests",
      "adminAnalytics.legalAnalyses": "Analyses",
      "adminAnalytics.legalVisitors": "Visitors",
      "adminAnalytics.legalRecentActivity": "Recent activity",
      "adminAnalytics.legalDay": "Day",
      "adminAnalytics.legalCount": "Count",
      "ingestionAnalytics.title": "Ingestion analytics",
      "ingestionAnalytics.unavailable": "Ingestion analytics unavailable",
      "ingestionAnalytics.loading": "Loading ingestion analytics...",
      "ingestionAnalytics.totalVisits": "Total visits",
      "ingestionAnalytics.todayVisitors": "Today's visitors",
      "ingestionAnalytics.pageViews": "Page views",
      "ingestionAnalytics.pageRefreshes": "Page refreshes",
      "ingestionAnalytics.topPages": "Top pages",
      "ingestionAnalytics.devices": "Devices",
      "ingestionAnalytics.sources": "Sources",
      "ingestionAnalytics.count": "Count",
      "ingestionAnalytics.page": "Page",
      "ingestionAnalytics.device": "Device",
      "ingestionAnalytics.source": "Source",
      "ingestionAnalytics.views": "Views",
      "ingestionAnalytics.noData": "No data",
      "ingestionAnalytics.sectionDesc": "Ingestion portal traffic (separate database; read-only summary)."
    }
  },
  ar: {
    translation: {
      "nav.home": "الرئيسية",
      "nav.features": "المميزات",
      "nav.services": "الخدمات",
      "nav.memorandums": "المذكرات القانونية",
      "nav.pleadings": "المرافعات القضائية",
      "nav.legalDiscussion": "المناقشة القانونية",
      "nav.contactUs": "تواصل معنا",
      "nav.contact": "تواصل معنا",
      "nav.tools": "الأدوات",
      "nav.firmArchive": "أرشيف القضايا",
      "navGroups.workspace": "مساحة العمل القانونية",
      "navGroups.products": "منتجات ديموي",
      "navGroups.general": "عام",
      "nav.pricing": "الأسعار",
      "nav.login": "تسجيل الدخول",
      "nav.getStarted": "ابدأ الآن",
      "brand.name": "يمناك",
      "header.onlineNow": "متصل الآن",
      "header.offline": "غير متصل",
      "header.guestBadge": "زائر",
      "hero.title": "من أول سؤال قانوني إلى إدارة مكتب كامل",
      "hero.descriptionLine1": "وفر ساعات إعداد اللوائح",
      "hero.descriptionLine2": "اعرف موقفك القانوني خلال دقائق",
      "hero.descriptionLine3": "أدر مكتبك كاملًا من مكان واحد",
      "hero.subtitle": "من أول سؤال قانوني إلى إدارة مكتب كامل — وفر الوقت في إعداد اللوائح، واعرف موقفك، وأدر مكتبك من مكان واحد.",
      "hero.cta": "ابدأ الآن",
      "hero.login": "تسجيل الدخول",
      "landingQuestion.placeholder": "اكتب سؤالك القانوني هنا…",
      "landingQuestion.submit": "اسأل الآن",
      "landingQuestion.emptyError": "يرجى كتابة السؤال قبل الإرسال.",
      "landingQuestion.helper": "احصل على إجابة قانونية موجّهة — سجّل لاحقًا لعرض الإجابة كاملة.",
      "hero.mockup.badge": "استشارة قانونية ذكية",
      "hero.mockup.questionLabel": "سؤال",
      "hero.mockup.questionText": "هل يحق لصاحب العمل إنهاء عقد الموظف دون إشعار مسبق في حال تكرار الغياب؟",
      "hero.mockup.answerLabel": "YimnakAI",
      "hero.mockup.answerText": "يعتمد ذلك على طبيعة الغياب والضوابط النظامية المرتبطة به. في حال ثبت تكرار الغياب دون عذر مشروع وفق ما يحدده النظام، فقد يحق لصاحب العمل إنهاء العقد وفق الإجراءات النظامية المعتمدة.",
      "hero.mockup.refsTitle": "مرجع نظامي",
      "hero.mockup.ref1": "نظام العمل السعودي",
      "hero.mockup.ref2": "أحكام إنهاء العقود",
      "hero.mockup.ref3": "ضوابط الغياب والتأديب",
      "hero.mockup.footer": "تحليل مبني على الأنظمة السعودية",
      "systemPortal.title": "بوابة الأنظمة المتكاملة",
      "systemPortal.subtitle": "وصولٌ سريعٌ ومنضبط إلى الأنظمة المترابطة — مساعد Yimnak، منصة المكاتب Arsheef، ومنصة الاستيعاب والأنظمة (Legal Ingestion) — من مكانٍ واحدٍ وبواجهةٍ متماسكة.",
      "cards.yimnak.title": "يمناك",
      "cards.yimnak.subtitle": "Yimnak",
      "cards.yimnak.description": "المساعد القانوني الذكي — للمستخدمين والمهتمين: طرح الأسئلة والاسترشاد بنصوص مبسّطة مع احترام الخصوصية وحدود الاستشارة.",
      "cards.yimnak.cta": "الدخول إلى Ydim",
      "cards.arsheef.title": "الارشيف",
      "cards.arsheef.subtitle": "Arsheef",
      "cards.arsheef.description": "نظام المكاتب والمحامين: إدارة القضايا والموكلين والمهام من منصة واحدة مصمّمة لبيئة العمل القانوني.",
      "cards.arsheef.cta": "دخول المكاتب القانونية",
      "cards.systems.title": "الانظمة",
      "cards.systems.subtitle": "Legal Ingestion",
      "cards.systems.description": "منصة الأنظمة واللوائح والاستيعاب القانوني — استعراض النصوص، المواد، والتعديلات بشكل منظّم.",
      "cards.systems.cta": "الدخول إلى منصة الأنظمة",
      "cards.legalIntelligence.title": "محرك الذكاء القانوني",
      "cards.legalIntelligence.subtitle": "",
      "cards.legalIntelligence.description": "تحليل عقود ومستندات المنشأة تلقائيًا، كشف المخاطر، ومتابعة الالتزامات النظامية.",
      "cards.legalIntelligence.cta": "دخول محرك الذكاء القانوني",
      "quickAccess.home": "الرئيسية",
      "quickAccess.systems": "الأنظمة",
      "quickAccess.officeLogin": "دخول المكاتب",
      "quickAccess.platform": "منصة الأنظمة",
      "quickAccess.contact": "تواصل معنا",
      "appLauncher.title": "المشاريع",
      "appLauncher.openMenu": "فتح قائمة المشاريع",
      "appLauncher.closeMenu": "إغلاق قائمة المشاريع",
      "appLauncher.ydim": "يمناك",
      "appLauncher.arsheef": "إدارة القضايا",
      "appLauncher.ingestion": "الأنظمة القانونية",
      "appLauncher.legalIntelligence": "مراجعة العقود باستخدام الذكاء الاصطناعي",
      "appLauncher.ydimDesc": "مساعد قانوني ذكي للأسئلة والاسترشاد.",
      "appLauncher.arsheefDesc": "إدارة القضايا والموكلين وسير عمل المكتب من مكان واحد.",
      "appLauncher.ingestionDesc": "استعراض الأنظمة واللوائح والمواد القانونية بشكل منظّم.",
      "appLauncher.legalDesc": "مراجعة العقود وكشف المخاطر ومتابعة الالتزام بالذكاء الاصطناعي.",
      "contactForm.title": "تواصل معنا",
      "contactForm.subtitle": "يسعدنا استقبال استفساراتكم وملاحظاتكم",
      "contactForm.name": "الاسم الكامل",
      "contactForm.email": "البريد الإلكتروني",
      "contactForm.subject": "الموضوع",
      "contactForm.message": "الرسالة",
      "contactForm.submit": "إرسال الرسالة",
      "contactForm.sending": "جاري الإرسال…",
      "contactForm.success": "تم إرسال رسالتك. سنعاود الاتصال بك قريباً.",
      "contactForm.error.required": "يرجى تعبئة جميع الحقول المطلوبة.",
      "contactForm.error.messageLength": "النص أطول من المسموح.",
      "contactForm.error.generic": "تعذر إرسال الرسالة. يرجى المحاولة لاحقاً.",
      "contactForm.error.notConfigured": "خدمة التواصل غير مهيأة على الخادم. يمكنك مراسلتنا على البريد مباشرة.",
      "contactForm.error.rateLimit": "طلبات كثيرة. يرجى المحاولة لاحقاً.",
      "contactForm.infoTitle": "راسلنا عبر البريد",
      "contactForm.infoNote": "نسعى للرد خلال 1–2 يوم عمل.",
      "contactForm.subject.enterprise": "استفسار عن باقة المؤسسات / الاشتراك المخصص",
      "trust.title": "موثوق من قبل فرق قانونية ومكاتب محترفة",
      "trust.lawFirms": "مكاتب محاماة",
      "trust.legalDepts": "إدارات قانونية",
      "trust.compliance": "فرق الامتثال",
      "trust.enterprises": "الشركات",
      "features.title": "كل ما تحتاجه للعمل القانوني الحديث",
      "features.subtitle": "أدوات قوية مصممة للمحامين والإدارات القانونية وفرق الامتثال.",
      "feature.memorandums": "إعداد المذكرات القانونية",
      "feature.memorandums.desc": "إعداد وهيكلة المذكرات القانونية بمساعدة الذكاء الاصطناعي وفق الأنظمة السعودية.",
      "feature.contracts": "تحليل العقود",
      "feature.contracts.desc": "تحليل العقود، تحديد المخاطر، والحصول على توصيات واضحة.",
      "feature.research": "البحث القانوني",
      "feature.research.desc": "إجابات سريعة وموثقة لأعقد المسائل القانونية السعودية.",
      "feature.summary": "تلخيص المستندات",
      "feature.summary.desc": "تلخيص المستندات الطويلة واستخراج النقاط القانونية الأساسية.",
      "feature.litigation": "دعم الأعمال القضائية",
      "feature.litigation.desc": "دعم المرافعات وتحليل القضايا والتحضير للمحكمة.",
      "feature.knowledge": "تنظيم المعرفة القانونية",
      "feature.knowledge.desc": "تنظيم وبحث المعرفة القانونية في مكان واحد.",
      "feature.review": "المراجعة والصياغة",
      "feature.review.desc": "مراجعة وتحسين النص القانوني باقتراحات ذكية.",
      "feature.bilingual": "مساعد قانوني ثنائي اللغة",
      "feature.bilingual.desc": "دعم كامل بالعربية والإنجليزية للعمل السعودي والدولي.",
      "usecases.title": "كيف تعمل المنصة",
      "usecases.subtitle": "من سؤالك إلى مخرجات قانونية جاهزة في ثلاث خطوات.",
      "usecases.step1": "ارفع المستند أو اطرح سؤالك",
      "usecases.step2": "يحلل النظام الوقائع والسياق القانوني",
      "usecases.step3": "احصل على مسودة أو تحليل أو توصية عملية",
      "testimonials.title": "ماذا يقول الفرق القانونية",
      "testimonials.subtitle": "آراء تمثيلية من محترفين يستخدمون المنصة.",
      "testimonial1.quote": "ساعدتنا المنصة على تسريع إعداد المسودات القانونية والحفاظ على اتساق الإجابات.",
      "testimonial1.role": "فريق قانوني",
      "testimonial2.quote": "نستخدمها لمراجعة العقود والبحث—توفر الوقت وتحسّن سير العمل.",
      "testimonial2.role": "مستشار داخلي",
      "testimonial3.quote": "إجابات واضحة وموثقة نعتمد عليها في المسائل النظامية السعودية.",
      "testimonial3.role": "فريق الامتثال",
      "metrics.memorandums": "تسريع إعداد المذكرات",
      "metrics.access": "تحسين الوصول للمعلومة القانونية",
      "metrics.teams": "دعم فرق العمل القانونية",
      "cta.title": "ابدأ العمل القانوني بذكاء أعلى",
      "cta.subtitle": "أنشئ حسابك واحصل على المذكرات والبحث ودعم المرافعات.",
      "cta.register": "إنشاء حساب",
      "cta.login": "تسجيل الدخول",
      "chat.title": " حوّل مشكلتك القانونية إلى إجراء نظامي واضح خلال دقائق",
      "chat.subtitle": "اشرح مشكلتك، وسيحللها يمناك نظاميًا، يحذرك من الأخطاء، ويقترح لك الإجراء الصحيح مع مستند جاهز عند الحاجة.",
      "tools.title": "تكامل سلس",
      "tools.subtitle": "يتصل بأدواتك المفضلة لأتمتة سير عملك القانوني.",
      "tools.page.title": "الأدوات القانونية",
      "tools.page.subtitle": "أدوات قانونية عملية مدمجة داخل Ydim بنفس تجربة الاستخدام الحالية، مع تصميم نظيف ومهيأ للتوسعة.",
      "tools.page.switcherAriaLabel": "مبدل الأدوات القانونية",
      "tools.common.currency.sar": "{{amount}} ريال",
      "tools.roadmap.title": "جاهزية مستقبلية",
      "tools.roadmap.feature.reply-letter-generator": "مولد خطاب الرد / الجواب",
      "tools.roadmap.feature.firm-mode-prefill": "التعبئة المسبقة من Firm Mode",
      "tools.roadmap.feature.office-templates": "قوالب المكاتب",
      "tools.roadmap.feature.subscription-gating": "بوابة الاشتراكات",
      "tools.eos.title": "حاسبة نهاية الخدمة",
      "tools.eos.subtitle": "تقدير أولي لمكافأة نهاية الخدمة وفق قواعد احتساب معيارية قابلة للتوسعة لاحقًا.",
      "tools.eos.field.monthlySalary": "الراتب الشهري (ريال)",
      "tools.eos.field.startDate": "تاريخ بداية العمل",
      "tools.eos.field.endDate": "تاريخ نهاية العمل",
      "tools.eos.field.terminationType": "سبب إنهاء العلاقة",
      "tools.eos.field.contractType": "نوع العقد",
      "tools.eos.placeholder.monthlySalary": "مثال: 8000",
      "tools.eos.option.termination.employer": "إنهاء من جهة صاحب العمل",
      "tools.eos.option.termination.resignation": "استقالة",
      "tools.eos.option.termination.contractEnd": "انتهاء العقد",
      "tools.eos.option.contract.unlimited": "غير محدد المدة",
      "tools.eos.option.contract.fixed": "محدد المدة",
      "tools.eos.validation.invalidInput": "تعذر احتساب المكافأة بسبب نقص أو عدم صحة المدخلات.",
      "tools.eos.result.estimatedAmount": "المبلغ التقديري",
      "tools.eos.result.explanation": "تم احتساب مدة خدمة تقديرية قدرها {{serviceYears}} سنة على أساس راتب شهري {{salary}} ريال.",
      "tools.eos.result.assumptionsHeading": "افتراضات الاحتساب",
      "tools.eos.result.notesHeading": "تنبيه مهم",
      "tools.eos.assumption.validSalary": "يجب إدخال راتب شهري صحيح.",
      "tools.eos.assumption.validDates": "تاريخ نهاية الخدمة يجب أن يكون بعد تاريخ البداية.",
      "tools.eos.assumption.saudiRule": "الاحتساب مبني على قواعد تقديرية شائعة في نظام العمل السعودي.",
      "tools.eos.assumption.exclusions": "لا يشمل هذا التقدير البدلات أو الحالات الاستثنائية أو التسويات الخاصة.",
      "tools.eos.assumption.contract.fixed": "نوع العقد المختار: محدد المدة.",
      "tools.eos.assumption.contract.unlimited": "نوع العقد المختار: غير محدد المدة.",
      "tools.eos.multiplier.employerOrContractEnd": "إنهاء الخدمة من جهة صاحب العمل أو انتهاء العقد: احتساب كامل الاستحقاق التقديري.",
      "tools.eos.multiplier.resignation.lt2": "الاستقالة قبل إكمال سنتين: لا تستحق مكافأة نهاية خدمة وفق القاعدة التقديرية المبسطة.",
      "tools.eos.multiplier.resignation.2to5": "الاستقالة بعد سنتين وقبل خمس سنوات: ثلث الاستحقاق التقديري.",
      "tools.eos.multiplier.resignation.5to10": "الاستقالة بعد خمس سنوات وقبل عشر سنوات: ثلثا الاستحقاق التقديري.",
      "tools.eos.multiplier.resignation.gte10": "الاستقالة بعد عشر سنوات فأكثر: كامل الاستحقاق التقديري.",
      "tools.eos.note.preliminary": "النتيجة لأغراض التقدير الأولي فقط.",
      "tools.eos.note.consultLawyer": "يرجى مراجعة محامٍ أو جهة مختصة قبل اتخاذ أي إجراء قانوني نهائي.",
      "tools.demand.title": "مولد خطاب المطالبة",
      "tools.demand.subtitle": "نموذج عربي احترافي قابل للنسخ والطباعة، مبني على قالب قانوني واضح.",
      "tools.demand.field.creditorName": "اسم الدائن / المطالب",
      "tools.demand.field.debtorName": "اسم المدين",
      "tools.demand.field.amount": "قيمة المطالبة (ريال)",
      "tools.demand.field.claimBasis": "سبب المطالبة",
      "tools.demand.field.dueDate": "تاريخ الاستحقاق (اختياري)",
      "tools.demand.field.paymentPeriodDays": "أو مهلة السداد بالأيام",
      "tools.demand.field.notes": "ملاحظات إضافية (اختياري)",
      "tools.demand.placeholder.creditorName": "مثال: أحمد القحطاني",
      "tools.demand.placeholder.debtorName": "مثال: شركة XYZ",
      "tools.demand.placeholder.amount": "مثال: 25000",
      "tools.demand.placeholder.claimBasis": "مثال: مستحقات عقد خدمات",
      "tools.demand.placeholder.paymentPeriodDays": "مثال: 7",
      "tools.demand.placeholder.notes": "أي تفاصيل إضافية ترغب بإدراجها في الخطاب",
      "tools.demand.result.finalText": "النص النهائي (قابل للنسخ والطباعة)",
      "tools.demand.action.copy": "نسخ الخطاب",
      "tools.demand.action.copied": "تم النسخ",
      "tools.demand.action.print": "طباعة",
      "login.title": "مرحباً بعودتك",
      "login.email": "البريد الإلكتروني",
      "login.password": "كلمة المرور",
      "login.submit": "تسجيل الدخول",
      "footer.rights": "© 2025 YimnakAI. جميع الحقوق محفوظة.",
      "footer.product": "المنتج",
      "footer.company": "الشركة",
      "footer.about": "عن الشركة",
      "footer.blog": "المدونة",
      "footer.contact": "اتصل بنا",
      "footer.privacy": "سياسة الخصوصية",
      "footer.terms": "شروط الخدمة",
      "chat.instructions.general": "اشرح مشكلتك القانونية، وسيقوم يمناك بتحليلها وفق الأنظمة السعودية، وتنبيهك للمخاطر المحتملة، واقتراح الإجراء القانوني الأنسب.",
      "chat.instructions.memorandum": "يرجى كتابة ملخص واضح للمشكلة أو النزاع المراد تقديم الدعوى بشأنه، مع ذكر الوقائع الأساسية دون تضمين بيانات حساسة أو أسماء صريحة، وذلك لتمكين إعداد لائحة دعوى دقيقة ومنظمة.",
      "chat.instructions.pleadings": "يرجى إدخال نص المرافعة أو الحكم القضائي المراد تحليله من حيث المخاطر النظامية والثغرات الإجرائية والنتيجة القضائية.",
      "journey.contact": "فهم المشكلة → تحليل نظامي → تنبيه المخاطر → اقتراح الإجراء القانوني",
      "journey.chat": "تلخيص الوقائع → التكييف النظامي → إعداد المذكرة → الصيغة النهائية",
      "journey.pleadings": "قراءة الحكم → التحليل الإجرائي → الثغرات النظامية → النتيجة القضائية",


      // Merged from LanguageContext
      "home": "الرئيسية",
      "contact": "المناقشة القانونية",
      "chat": "إعداد لوائح",
      "Memorandum":"المذكرات واللوائح القانونية",
      "logout": "تسجيل الخروج",
      "pleadings": "المرافعات القضائية",
      "welcomeTitle": "مرحباً بك في يمناك",
      "welcomeSubtitle": "استخدم الذكاء الاصطناعي القانوني مع إمكانيات الدردشة المتكاملة والمراجعة الموثوقة.",
      "realTimeChat": "المناقشة القانونية",
      "realTimeChatDesc": "احصل على إجابات قانونية فورية ودقيقة، مدعومة بالذكاء الاصطناعي ومبنية على الأنظمة واللوائح السعودية الرسمية",
      "ourServices": "خدماتنا",
      "ourServicesDesc": "استكشف مجموعة شاملة من خدماتنا المهنية.",
      "analytics": "إعداد اللوائح والمذكرات القانونية",
      "analyticsDesc": "إعداد المذكرات القانونية بالذكاء الاصطناعي وفق الأنظمة السعودية مع توضيح خطوات تقديمها،مع تقييم نسبة قوة المركز القانوني.",
      "pleadingsDesc": "تحليل الأحكام والمرافعات القضائية بشكل منظم، مع كشف الثغرات النظامية والمراجعة الإجرائية.",
      "contactSupport": " المناقشة القانونية",
      "contactSubtitle": "نحن هنا لمساعدتك! أرسل لنا رسالة وسنرد عليك.",
      "typeMessage": "اكتب رسالتك هنا...",
      "send": "إرسال",
      "you": "أنت",
      "bot": "البوت",
      "welcomeMessage": "مرحباً! كيف يمكنني مساعدتك اليوم؟",
      "errorMessage": "⚠️ عذراً، حدثت مشكلة في الاتصال بالخادم.",
      "newChat": "دردشة جديدة",
      "copyMessage": "نسخ الرسالة",
      "likeMessage": "إعجاب بالرسالة",
      "dislikeMessage": "عدم إعجاب بالرسالة",
      "shareMessage": "مشاركة الرسالة",
      "scrollToBottom": "الانتقال للأسفل",
      "ourServicesTitle": "خدماتنا",
      "ourServicesSubtitle": "خدمات قانونية مهنية مصممة لتلبية احتياجات عملك",
      "legalConsultations": "الاستشارات القانونية",
      "legalConsultationsDesc": "خدمات الاستشارة والنصيحة القانونية المهنية",
      "contractDrafting": "صياغة العقود",
      "contractDraftingDesc": "صياغة عقود مخصصة تناسب احتياجاتك الخاصة",
      "contractReview": "مراجعة العقود",
      "contractReviewDesc": "مراجعة وتحليل شامل للعقود الموجودة",
      "legalMemorandums": "كتابة المذكرات القانونية",
      "legalMemorandumsDesc": "خدمات كتابة المذكرات القانونية المهنية",
      "allRightsReserved": "جميع الحقوق محفوظة.",
      "privacyPolicy": "سياسة الخصوصية",
      "termsOfService": "شروط الخدمة",
      
      
      // Privacy Policy
      "privacyPolicy.title": "سياسة الخصوصية",
      "privacyPolicy.subtitle": "يمناك (Ydim) — إطار واضح لحماية البيانات الشخصية والمستندات وسير العمل المدعوم بالذكاء الاصطناعي في بيئة SaaS مهنية.",
      "privacyPolicy.introduction.title": "المقدمة",
      "privacyPolicy.introduction.body": "يمناك (Ydim) منصة تقنية سعودية تساعد الأفراد والمنشآت ومكاتب المحاماة على تنظيم القضايا وتحليل المستندات ودعم سير العمل المهني باستخدام الذكاء الاصطناعي. توضّح هذه السياسة أنواع البيانات التي قد نعالجها، وأسباب المعالجة، وضوابط الوصول والاحتفاظ، والخيارات المتاحة لك. نلتزم بالأنظمة المعمول بها في المملكة العربية السعودية، بما في ذلك نظام حماية البيانات الشخصية (PDPL) وما يصدر عنه من لوائح وتعليمات.",
      "privacyPolicy.serviceNature.title": "طبيعة الخدمة",
      "privacyPolicy.serviceNature.body": "يوفّر Ydim برمجيات وأدوات رقمية لإدارة مساحات العمل، وتتبع القضايا، وتحليل النصوص والمستندات، وإعداد مسودات تشغيلية. يمناك ليست مكتب محاماة ولا تمثل العميل أمام الجهات القضائية أو الإدارية، ولا تقدّم استشارات قانونية ملزمة أو علاقة محامٍ–موكل. المخرجات معلوماتية وتنظيمية لدعم الحكم المهني؛ يبقى المختص المؤهل مسؤولاً عن المراجعة والقرار والتقديم والإجراءات النظامية.",
      "privacyPolicy.aiUse.title": "استخدام الذكاء الاصطناعي",
      "privacyPolicy.aiUse.body": "تستخدم بعض الميزات نماذج ذكاء اصطناعي للتلخيص، وإبراز المخاطر، وصياغة مسودات، أو اقتراح خطوات تشغيلية. قد تكون النتائج ناقصة أو خاطئة أو غير مناسبة لسياقك؛ يجب مراجعتها من مختص مؤهل قبل الاعتماد عليها أو مشاركتها مع الغير. قد تُنفَّذ أجزاء من المعالجة عبر مزودي خدمات خارجيين موثوقين للاستضافة أو الاستدلال أو الأمن، وفق ضوابط تعاقدية وحدود استخدام محددة. لا نستخدم محتواك لتدريب نماذج عامة إلا بإفصاح واضح وموافقتك عندما يُطلب ذلك.",
      "privacyPolicy.documents.title": "معالجة الملفات والمستندات",
      "privacyPolicy.documents.description": "عند رفع ملفات أو إدخال بيانات مرتبطة بالقضايا أو العقود أو المراسلات، نعالجها لتقديم الميزة التي طلبتها. نتعامل مع المستندات والبيانات الحساسة بمبدأ الحد الأدنى من الوصول والاستخدام اللازم للخدمة، مع ضوابط نقل وتخزين مناسبة لطبيعة المحتوى. قد يشمل ذلك:",
      "privacyPolicy.documents.item1": "معرّفات الحساب وبيانات التواصل وسياق مساحة العمل أو المكتب والصلاحيات.",
      "privacyPolicy.documents.item2": "محتوى المستندات وبياناتها الوصفية ومخرجات التحليل (محادثات، مذكرات، مرافعات، مراجعة عقود، وتنبيهات).",
      "privacyPolicy.documents.item3": "سجلات تقنية للأمن ومنع إساءة الاستخدام والفوترة وقياس جودة الخدمة.",
      "privacyPolicy.documents.item4": "نصوص مُقنّعة أو مُخفّفة الحساسية عند تطبيق ضوابط الخصوصية قبل أي معالجة لاحقة.",
      "privacyPolicy.firmMode.title": "وضع المكاتب (Firm Mode)",
      "privacyPolicy.firmMode.body": "وضع المكاتب مخصّص لمكاتب المحاماة والفرق المهنية والمؤسسات التي تدير ملفات متعددة. تُعزل بيانات كل مكتب أو مساحة عمل منطقيًا عن غيرها، ويُقيَّد الوصول بالمستخدمين المصرّح لهم وفق أدوار داخلية يديرها مسؤولو المكتب. لا ندمج قضايا أو مستندات مكتب بآخر، ولا نعرض بيانات مؤسسة لمستخدمين خارج نطاقها، إلا بسند نظامي وتعليمات صريحة. عند تفعيل اشتراكات مؤسسية، نطبّق فصلًا تشغيليًا بين بيئات العمل قدر الإمكان لتقليل مخاطر الخلط أو الوصول غير المصرّح به.",
      "privacyPolicy.pdpl.title": "حماية البيانات والامتثال لـ PDPL",
      "privacyPolicy.pdpl.body": "نطبّق ضوابط إدارية وتقنية وتنظيمية مناسبة لحساسية البيانات المهنية والتجارية، بما في ذلك التحكم بالوصول، والتشفير أثناء النقل حيث يُدعم، والمراقبة، وحدود الاحتفاظ، وإجراءات الاستجابة للحوادث. نُقلّل من جمع البيانات الشخصية إلى ما يلزم لتقديم الخدمة والامتثال، ونقيّد الوصول الداخلي حسب الحاجة والصلاحية. يمكنك طلب الاطلاع أو التصحيح أو الحذف للبيانات الشخصية حيث يسمح النظام وسجلاتنا. نستجيب للطلبات النظامية من الجهات المختصة عند الوجوب، مع مراعاة التزامات السرية المهنية قدر الإمكان.",
      "privacyPolicy.liability.title": "حدود المسؤولية",
      "privacyPolicy.liability.body": "تُقدَّم المنصة كأداة مهنية. في الحدود التي يجيزها النظام، لا تتحمل يمناك خسائر ناتجة عن مخرجات ذكاء اصطناعي غير مُراجعة أو إعداد خاطئ من المستخدم أو استخدام مخالف لهذه السياسة. لا يُخل ذلك بحقوق المستهلك الإلزامية أو المسؤوليات التي لا يجوز إسقاطها بموجب الأنظمة السعودية.",
      "privacyPolicy.prohibitedUse.title": "الاستخدام المحظور",
      "privacyPolicy.prohibitedUse.description": "يُحظر استخدام Ydim من أجل:",
      "privacyPolicy.prohibitedUse.item1": "رفع محتوى مخالف للنظام أو غير مصرّح لك بمشاركته.",
      "privacyPolicy.prohibitedUse.item2": "محاولة تجاوز الأمن أو عزل المستأجرين أو الوصول لبيانات عميل آخر.",
      "privacyPolicy.prohibitedUse.item3": "استبدال التمثيل المهني المنظّم دون مراجعة مهنية مستقلة.",
      "privacyPolicy.prohibitedUse.item4": "السحب الآلي أو إعادة البيع أو الهندسة العكسية للخدمة إلا بما يُسمح به في اتفاقيتك معنا.",
      "privacyPolicy.retention.title": "الاحتفاظ بالبيانات",
      "privacyPolicy.retention.body": "نحتفظ بالبيانات الشخصية ومحتوى مساحات العمل للمدة اللازمة للخدمة والفوترة والأمن والالتزامات النظامية، ثم نحذفها أو نُخفي هويتها وفق جداولنا وإعداداتك حيث تتوفر. قد تبقى النسخ الاحتياطية لفترة محدودة قبل التدوير.",
      "privacyPolicy.cookies.title": "ملفات تعريف الارتباط والتقنيات المشابهة",
      "privacyPolicy.cookies.body": "نستخدم ملفات تعريف الارتباط والتخزين المحلي لجلسات الدخول والتفضيلات والتحليلات والأمن. يمكنك التحكم عبر المتصفح؛ تعطيل بعض الملفات قد يحدّ وظائف الموقع. لا نستخدمها لبيع البيانات الشخصية.",
      "privacyPolicy.contact.title": "التواصل",
      "privacyPolicy.contact.body": "للاستفسارات المتعلقة بالخصوصية أو طلبات PDPL أو بلاغات الأمن، تواصل عبر القنوات المنشورة في موقع يمناك أو الدعم داخل المنتج. نتحقق من هويتك قبل تعديل بيانات الحساب.",
      "privacyPolicy.consent.title": "موافقتك",
      "privacyPolicy.consent.description": "بإنشاء حساب أو الاستمرار في استخدام Ydim، تؤكد أنك قرأت هذه السياسة وتوافق على المعالجة كما هو موضّح. إن لم توافق، يُرجى التوقف عن استخدام الخدمة.",
      
      // Registration Privacy Policy Agreement
      "register.privacyAgreement": "أوافق على سياسة الخصوصية",
      "register.privacyAgreementError": "يجب الموافقة على سياسة الخصوصية قبل التسجيل",
      
      // Pricing
      "pricing.title": "الأسعار",
      "pricing.subtitle": "اختر الخطة المناسبة لك",
      "pricing.recommended": "موصى به",
      "pricing.billingInterval.label": "فترة الفوترة",
      "pricing.billingInterval.monthly": "شهري",
      "pricing.billingInterval.annual": "سنوي",
      "pricing.checkoutReturn.confirming": "تم استلام الدفع. جارٍ تأكيد اشتراكك وقد يستغرق ذلك لحظات.",
      "pricing.checkoutReturn.failed": "لم يكتمل الدفع.",
      "pricing.checkoutReturn.checking": "جارٍ التحقق من حالة الدفع.",
      "pricing.checkoutReturn.active": "اشتراكك أصبح نشطاً الآن.",
      "pricing.checkoutReturn.pending": "تم استلام الدفع، لكن تفعيل الاشتراك ما زال قيد المعالجة. يرجى التحديث لاحقاً أو التواصل مع الدعم.",
      "pricing.free.name": "مجاني",
      "pricing.free.price": "مجاني",
      "pricing.free.description": "مثالي للبدء",
      "pricing.free.feature1": "استشارات قانونية أساسية",
      "pricing.free.feature2": "رسائل محادثة محدودة",
      "pricing.free.feature3": "وقت استجابة قياسي",
      "pricing.free.feature4": "دعم المجتمع",
      "pricing.free.button": "ابدأ الآن",
      "pricing.pro.name": "احترافي",
      "pricing.pro.price": "99 ر.س شهرياً",
      "pricing.pro.description": "للمحترفين والشركات",
      "pricing.pro.feature1": "استشارات قانونية غير محدودة",
      "pricing.pro.feature2": "رسائل محادثة غير محدودة",
      "pricing.pro.feature3": "دعم ذو أولوية",
      "pricing.pro.feature4": "ميزات ذكاء اصطناعي متقدمة",
      "pricing.pro.feature5": "تحليل المستندات",
      "pricing.pro.button": "الترقية الآن",
      "pricing.office.name": "مكتب",
      "pricing.office.description": "للمكاتب القانونية والفرق",
      "pricing.office.feature1": "كل مزايا احترافي",
      "pricing.office.feature2": "مساحة عمل للمكتب",
      "pricing.office.feature3": "إدارة قضايا المكتب",
      "pricing.office.feature4": "سعة أعلى للفريق",
      "pricing.office.feature5": "دعم ذو أولوية",
      "pricing.office.button": "الترقية الآن",
      "pricing.enterprise.name": "المؤسسات",
      "pricing.enterprise.price": "تواصل معنا",
      "pricing.enterprise.description": "للمؤسسات الكبيرة",
      "pricing.enterprise.feature1": "كل ما في الخطة الاحترافية",
      "pricing.enterprise.feature2": "مدير حساب مخصص",
      "pricing.enterprise.feature3": "تكاملات مخصصة",
      "pricing.enterprise.feature4": "ضمانات اتفاقية مستوى الخدمة",
      "pricing.enterprise.feature5": "خيارات النشر الداخلية",
      "pricing.enterprise.button": "اتصل بنا",
      "upgrade.title": "ترقية الخطة",
      "upgrade.confirmWithBilling": "هل أنت متأكد من الترقية إلى {{planId}} (فوترة {{billingInterval}})؟",
      "upgrade.billingIntervalNote": "سيتم تحصيل سعر فترة الفوترة المختارة عند الدفع.",
      "upgrade.trialNote": "سيتم تطبيق هذه الترقية كفترة تجريبية دون دفع.",
      "upgrade.continueToPayment": "متابعة إلى الدفع",
      "upgrade.checkoutFailed": "تعذر تجهيز الدفع.",
      "upgrade.cancel": "إلغاء",
      "upgrade.processing": "جاري المعالجة...",

      "adminPage.title": "لوحة الإدارة",
      "adminPage.subtitle": "تحليلات المناقشة القانونية ومراقبة النشاط",
      "adminPage.loading": "جارٍ تحميل اللوحة…",
      "adminPage.platformTitle": "مقاييس المنصة",
      "adminPage.platformDesc": "ملخص سريع للمستخدمين والزوار ونشاط المحادثة.",
      "adminPage.interactionsTitle": "آخر التفاعلات",
      "adminPage.interactionsDesc": "أحدث أسئلة المحادثة وإجاباتها. انقر على صف لعرض التفاصيل.",
      "adminPage.emptyInteractions": "لا توجد بيانات حالياً",
      "adminPage.guest": "زائر",
      "adminPage.prev": "السابق",
      "adminPage.next": "التالي",
      "adminPage.pageInfo": "الصفحة {{current}} من {{total}}",
      "adminPage.colDate": "التاريخ / الوقت",
      "adminPage.colSession": "الجلسة",
      "adminPage.colUser": "المستخدم",
      "adminPage.colSource": "المصدر",
      "adminPage.colQuestion": "السؤال",
      "adminPage.colAnswer": "الإجابة",
      "adminPage.modalTitle": "تفاصيل التفاعل",
      "adminPage.close": "إغلاق",
      "adminPage.labelDate": "التاريخ / الوقت",
      "adminPage.labelSession": "معرّف الجلسة",
      "adminPage.labelUser": "معرّف المستخدم",
      "adminPage.labelSource": "الصفحة المصدر",
      "adminPage.labelQuestion": "السؤال",
      "adminPage.labelAnswer": "الإجابة",
      "adminPage.scrollRegion": "المزيد من الصفوف",
      "adminPage.metricTotalUsers": "إجمالي المستخدمين (مميّز)",
      "adminPage.metricRegistered": "المسجّلون",
      "adminPage.metricVisitors": "الزائرون (جلسات مميّزة)",
      "adminPage.metricVisits": "الزيارات (تحميلات الصفحات)",
      "adminPage.metricInteractions": "إجمالي التفاعلات",
      "adminPage.metricToday": "تفاعلات اليوم",
      "adminPage.metric24h": "آخر ٢٤ ساعة",

      "adminHub.shellTitle": "مركز التشغيل",
      "adminHub.shellSubtitle": "رؤية تجارية وتشغيلية للقراءة فقط — واجهات إدارية منظمة (Sprint 3.3) دون دفع أو إنفاذ إنتاجي.",
      "adminHub.sidebarAria": "أقسام الإدارة",
      "adminHub.navOverview": "نظرة عامة",
      "adminHub.navLegacyDashboard": "لوحة الإدارة الحالية",
      "adminHub.navCommercial": "التجاري",
      "adminHub.navPlans": "كتالوج الخطط",
      "adminHub.navEntitlements": "معاينة الاستحقاقات",
      "adminHub.navGuestPolicies": "سياسات الضيف",
      "adminHub.navFirmMode": "معاينة وضع المكتب",
      "adminHub.navAiUsagePolicies": "سياسات استخدام الذكاء",
      "adminHub.navOperations": "التشغيل",
      "adminHub.navAiVisibility": "رؤية الاستخدام والذكاء",
      "adminHub.navOperationalHealth": "الصحة التشغيلية",
      "adminHub.navAsyncJobs": "جاهزية المهام غير المتزامنة",
      "adminHub.navOrganizations": "المنظمات",
      "adminHub.navOfficesConsumption": "المكاتب والاستهلاك",
      "adminHub.navPlatform": "المنصة",
      "adminHub.navFeatureFlags": "أعلام الميزات والفوترة",
      "adminHub.navServiceReadiness": "جاهزية الخدمات",
      "adminHub.navObservability": "المراقبة والتحليلات",
      "adminHub.observabilityTitle": "المراقبة والتحليلات",
      "adminHub.observabilityDesc": "مقاييس يمناك داخل العملية وفحوص صحة محلية للخدمات الداخلية (للقراءة فقط).",
      "adminHub.capPlatformObservability": "صحة الخدمات ومقاييس الطلبات لمالك النظام.",
      "adminObs.refreshData": "تحديث البيانات",
      "adminObs.lastUpdated": "آخر تحديث",
      "adminObs.metricsDisabled": "المراقبة غير مفعلة. فعّل ENABLE_METRICS=true في بيئة التشغيل.",
      "adminObs.loadError": "تعذر تحميل بيانات المراقبة حالياً.",
      "adminObs.accessDenied": "يلزم صلاحية إدارة لعرض المراقبة.",
      "adminObs.sectionYdim": "يمناك",
      "adminObs.sectionServices": "الخدمات الداخلية",
      "adminObs.cardYdimStatus": "حالة Ydim",
      "adminObs.cardRequestsTotal": "إجمالي الطلبات",
      "adminObs.cardResponseAvg": "متوسط الاستجابة",
      "adminObs.cardErrors4xx": "أخطاء 4xx",
      "adminObs.cardErrors5xx": "أخطاء 5xx",
      "adminObs.cardSentry": "حالة Sentry",
      "adminObs.cardPrivacyGateway": "حالة Privacy Gateway",
      "adminObs.cardLie": "حالة Legal Intelligence Engine",
      "adminObs.cardIngestion": "حالة Ingestion",
      "adminObs.statusAvailable": "متاح",
      "adminObs.statusUnknown": "غير معروف",
      "adminObs.statusUnavailable": "غير متاح",
      "adminObs.sentryOn": "مفعّل",
      "adminObs.sentryOff": "غير مفعّل",
      "adminObs.errorsByRouteTitle": "الأخطاء حسب المسار",
      "adminObs.errorsByRouteEmpty": "لا توجد استجابات 4xx أو 5xx مسجّلة حسب المسار بعد.",
      "adminObs.colStatus": "الحالة",
      "adminObs.colMethod": "الطريقة",
      "adminObs.colPath": "المسار",
      "adminObs.colCount": "العدد",
      "adminHub.loadError": "تعذر تحميل هذا القسم. تحقق من جلسة الإدارة وسجلات الخادم.",
      "adminHub.loadAction": "تحميل / تحديث",
      "adminHub.userIdLabel": "معرف مستخدم يمناك",
      "adminHub.planCode": "رمز الخطة",
      "adminHub.userKeyOptional": "user_key للاستخدام (اختياري)",
      "adminHub.dateFrom": "من (تاريخ UTC)",
      "adminHub.dateTo": "إلى (تاريخ UTC)",
      "adminHub.officeIdOptional": "تصفية مكتب (اختياري)",
      "adminHub.officePlanCode": "رمز خطة مكتب (اختياري)",
      "adminHub.asyncLimit": "حد الصفوف الأخيرة",
      "adminHub.asyncSummaryHeading": "ملخص المهام غير المتزامنة",
      "adminHub.asyncRecentHeading": "آخر سجلات platform_async_jobs",
      "adminHub.firmPreviewGuest": "اعتبار المستخدم ضيفًا",
      "adminHub.firmPreviewJwt": "محاكاة وجود رمز Firm",
      "adminHub.aiAllowanceNote": "اترك user_key فارغًا لمعاينة الحد فقط؛ أضف user_key والتواريخ لمقارنة التجميعات (معاينة ناعمة).",
      "adminHub.commercialPlansTitle": "كتالوج الخطط",
      "adminHub.commercialPlansDesc": "كتالوج الخطط من billing_plans مع الدمج الآمن — جدول + JSON اختياري (للقراءة فقط).",
      "adminHub.entitlementsTitle": "معاينة الاستحقاقات",
      "adminHub.entitlementsDesc": "الخطة الفعّالة وحصص usage.js — بطاقات وجدول + JSON اختياري.",
      "adminHub.guestPoliciesTitle": "سياسات الضيف",
      "adminHub.guestPoliciesDesc": "حدود الضيف والسياسة التجارية — جداول مقروءة + JSON اختياري (دون إنفاذ جديد).",
      "adminHub.firmModeTitle": "معاينة استحقاق وضع المكتب",
      "adminHub.firmModeDesc": "معاينة سيناريو — بطاقات منظمة؛ سلوك Firm الحي دون تغيير.",
      "adminHub.aiUsagePoliciesTitle": "معاينة حصة الذكاء",
      "adminHub.aiUsagePoliciesDesc": "حصة الذكاء مقابل التجميعات — بطاقات مقاييس + JSON اختياري (مراقبة فقط).",
      "adminHub.aiVisibilityTitle": "حزمة التشغيل والذكاء",
      "adminHub.aiVisibilityDesc": "حزمة تشغيلية — النافذة، الإجماليات، الاستدلالات، جداول، JSON قابل للطي.",
      "adminHub.opHealthTitle": "الصحة التشغيلية",
      "adminHub.opHealthDesc": "صحة ضمن نافذة — بطاقات واستدلالات + JSON اختياري.",
      "adminHub.asyncJobsTitle": "المهام غير المتزامنة",
      "adminHub.asyncJobsDesc": "platform_async_jobs — ملخص، جدول حسب الحالة، آخر المهام + JSON اختياري.",
      "adminHub.orgOfficesTitle": "المكاتب والاستهلاك",
      "adminHub.orgOfficesDesc": "استهلاك المكاتب — جدول + JSON اختياري (RBAC أرشيف دون تغيير).",
      "adminHub.flagsTitle": "أعلام الميزات والوصف",
      "adminHub.authLoginTitle": "تسجيل الدخول والتحقق",
      "adminHub.authLoginDesc": "مزود OTP وإظهار كلمة المرور. الأسرار تبقى في متغيرات البيئة فقط.",
      "adminHub.navAuthLogin": "تسجيل الدخول والتحقق",
      "adminHub.flagsDesc": "أعلام الفوترة مع الوصف الثابت — جدول + JSON اختياري (للقراءة).",
      "adminHub.readinessTitle": "جاهزية التكامل",
      "adminHub.readinessDesc": "تلميحات وجود المتغيرات — شبكة شارات + JSON اختياري (دون أسرار أو فحوص حية).",
      "adminHub.capOverview": "لوحة التحليلات الأصلية (التفاعلات وبطاقات يمناك/الاستيعاب/LIE).",
      "adminHub.capCommercialPlans": "لقطة كتالوج الخطط للمواءمة التجارية.",
      "adminHub.capCommercialEntitlements": "معاينة الخطة الفعّالة لكل مستخدم.",
      "adminHub.capCommercialGuest": "توثيق سياسة الضيف وحدود الكتالوج.",
      "adminHub.capCommercialFirm": "معاينة سيناريو استحقاق وضع المكتب.",
      "adminHub.capCommercialAi": "معاينة حصة الذكاء مقابل التجميعات.",
      "adminHub.capOpsInsights": "حزمة الرؤية التشغيلية الكاملة.",
      "adminHub.capOpsHealth": "جزء الصحة التشغيلية.",
      "adminHub.capOpsAsync": "رؤية سجل المهام غير المتزامنة.",
      "adminHub.capOrgOffices": "استهلاك المكاتب من تجميعات يمناك.",
      "adminHub.capPlatformFlags": "أعلام الفوترة والوصف.",
      "adminHub.capPlatformAuthLogin": "مزود OTP وتفعيل كلمة المرور.",
      "adminHub.capPlatformReadiness": "تلميحات جاهزية الخدمات عبر المتغيرات.",
      "adminHub.navEnforcementReadiness": "جسر الإنفاذ",
      "adminHub.enforcementTitle": "جسر إنفاذ الخطط",
      "adminHub.enforcementDesc": "جسر الإنفاذ — الوضع، إحصاءات shadow، تلميحات البيئة والفوترة + JSON اختياري (دون إنفاذ إنتاجي).",
      "adminHub.capCommercialEnforcement": "مراقبة جسر plan-resolver وعدادات عدم التطابق.",

      "adminKit.tableEmpty": "لا توجد صفوف للعرض.",
      "adminKit.rawJsonToggle": "JSON خام (متقدم)",
      "adminKit.rawBundleJson": "JSON كامل للاستجابة (متقدم)",
      "adminKit.planCatalogTableTitle": "كتالوج الخطط النشطة",
      "adminKit.planCatalogTableSub": "دمج صف قاعدة البيانات مع كتالوج الاحتياط لكل رمز خطة.",
      "adminKit.colPlanCode": "رمز الخطة",
      "adminKit.colAudience": "نوع الجمهور",
      "adminKit.colMonthly": "السعر الشهري",
      "adminKit.colAnnual": "السعر السنوي",
      "adminKit.colCurrency": "العملة",
      "adminKit.colActive": "المصدر / النشاط",
      "adminKit.colLimitsSummary": "ملخص الحصص",
      "adminKit.colAiSummary": "ملخص حدود الذكاء",
      "adminKit.colFirmHint": "وضع المكتب (حدود/ميزات)",
      "adminKit.colMetadataPreview": "بيانات وصفية (معاينة)",
      "adminKit.enforcementRuntimeTitle": "تشغيل الجسر",
      "adminKit.enforcementRuntimeSub": "قرارات السماح/الرفض HTTP تبقى من النظام القديم؛ هذه اللوحة للمراقبة فقط.",
      "adminKit.metricResolverBridge": "تفعيل جسر الـ resolver",
      "adminKit.metricResolverBridgeHint": "متغير البيئة أو علم plan_limits_resolver_paywall.",
      "adminKit.metricEnforcementMode": "الوضع الفعّال",
      "adminKit.metricEnforcementModeHint": "off | shadow | soft | enforce_later (غير مفعّل إنتاجيًا).",
      "adminKit.metricLegacySource": "مصدر الإنفاذ القديم",
      "adminKit.metricLegacySourceHint": "المرجع لقرارات 403 اليوم.",
      "adminKit.metricResolverSource": "مصدر الـ resolver",
      "adminKit.metricResolverSourceHint": "معاينة الكتالوج للمقارنة.",
      "adminKit.shadowStatsTitle": "عدادات المقارنة الظلية",
      "adminKit.metricMismatchCount": "عدم تطابق legacy/resolver",
      "adminKit.metricMismatchHint": "في الذاكرة منذ آخر إعادة تشغيل للخادم.",
      "adminKit.metricGuestHints": "تلميحات ضيف ناعمة",
      "adminKit.metricLastMismatch": "آخر عدم تطابق (UTC)",
      "adminKit.metricLastRoute": "آخر مسار",
      "adminKit.envHintsTitle": "تجاوزات البيئة",
      "adminKit.systemBillingFlagsTitle": "أعلام الفوترة (جزء)",
      "adminKit.colSetting": "الإعداد",
      "adminKit.colValue": "القيمة",
      "adminKit.yes": "نعم",
      "adminKit.no": "لا",
      "adminKit.set": "مضبوط",
      "adminKit.unset": "غير مضبوط",
      "adminKit.enforceLaterNotProduction": "وضع enforce_later محجوز — قرارات الإنتاج HTTP تتبع النظام القديم في Sprint 3.2–3.3.",
      "adminKit.guestSummaryTitle": "مصفوفة قدرات الضيف",
      "adminKit.guestSummarySub": "ملخص موحد من حمولة حدود الضيف.",
      "adminKit.guestAreaChat": "المحادثة",
      "adminKit.guestChatDetail": "تجربة محادثة محدودة للضيف وفق سياسة المنتج.",
      "adminKit.guestLimited": "محدود",
      "adminKit.guestYes": "نعم",
      "adminKit.guestAreaDocuments": "المستندات",
      "adminKit.guestDocDetail": "رفع المستندات غير متاح للضيف وفق سياسة المنتج.",
      "adminKit.guestAreaFirm": "وضع المكتب",
      "adminKit.guestFirmDetail": "يتطلب رمز أرشيف؛ الضيف لا يستلمه.",
      "adminKit.guestAreaArsheef": "أرشيف",
      "adminKit.guestArsheefDetail": "لا مسار دخول ضيف على أرشيف.",
      "adminKit.guestAreaHeavyLie": "تحليل LIE ثقيل",
      "adminKit.guestLieDetail": "التحليل الثقيل مُقيَّد عبر يمناك.",
      "adminKit.guestPolicyDocTitle": "وثيقة السياسة التجارية (القدرات)",
      "adminKit.guestCatalogLimitsTitle": "حصص وحدود الضيف من الكتالوج",
      "adminKit.guestEnforcementNote": "حقل enforcement في الاستجابة معلوماتي هنا — المسارات الحية دون تغيير.",
      "adminKit.guestSoftGeneric": "عينة تحذير ناعم للضيف (رفع مستند).",
      "adminKit.colArea": "المجال",
      "adminKit.colAllowed": "مسموح / الوضع",
      "adminKit.colDetail": "التفصيل",
      "adminKit.colCapability": "القدرة",
      "adminKit.colNote": "ملاحظة",
      "adminKit.colResource": "المورد",
      "adminKit.colQuotaCatalog": "الحصة (كتالوج)",
      "adminKit.colLimitCatalog": "الحد (كتالوج)",
      "adminKit.firmEntitlementTitle": "معاينة استحقاق وضع المكتب",
      "adminKit.firmEntitlementSub": "مدخلات السيناريو أعلاه — ليست حالة مستخدم حية.",
      "adminKit.firmModeEnabled": "firm_mode_enabled",
      "adminKit.firmModeSource": "firm_mode_source",
      "adminKit.addonRequired": "addon_required",
      "adminKit.officePlanCodeLabel": "office_plan_code",
      "adminKit.billingStatus": "billing_status",
      "adminKit.enforcementMode": "enforcement",
      "adminKit.planCode": "plan_code",
      "adminKit.resolverSource": "مصدر الـ resolver",
      "adminKit.audienceType": "audience_type",
      "adminKit.officePlanResolvedTitle": "خطة المكتب (معاينة resolver)",
      "adminKit.firmTemporaryExemptionWarn": "قد يكون إعفاء paywall لوضع المكتب نشطًا في المسارات الحية — اعتبره مؤقتًا حتى مواءمة فوترة المكاتب.",
      "adminKit.firmPreviewNoBehaviorChange": "معاينة فقط — دون تغيير توجيه Firm الحي.",
      "adminKit.aiAllowanceTitle": "معاينة حصة الذكاء",
      "adminKit.aiAllowanceSub": "من كتالوج الخطة/البيانات الوصفية؛ نافذة تجميعات عند تعيين user_key.",
      "adminKit.aiUsedUnitsWindow": "وحدات الاستخدام (النافذة)",
      "adminKit.aiRollupWindowHint": "مجموع user_usage_daily_rollups.usage_units_sum للتواريخ المختارة.",
      "adminKit.aiLimit": "الحد (وحدات)",
      "adminKit.aiUsed": "المستخدم (وحدات)",
      "adminKit.aiRemaining": "المتبقي (وحدات)",
      "adminKit.unlimited": "غير محدود",
      "adminKit.allowanceSource": "مصدر الحصة",
      "adminKit.aiWarningHint": "تحذير معاينة ناعم من الـ resolver (لا يوقف LIE/المحادثة).",
      "adminKit.aiTopTypesNote": "تفصيل usage_type متاح في التشغيل ← رؤية الذكاء، وليس في مسار الحصة هذا.",
      "adminKit.entitlementUserTitle": "سياق المستخدم",
      "adminKit.entitlementUserSub": "يُحمَّل من billing-access ومعاينة الـ resolver.",
      "adminKit.userId": "معرف المستخدم",
      "adminKit.planId": "معرف الخطة",
      "adminKit.accountKind": "نوع الحساب",
      "adminKit.resolverEnforcement": "علم enforcement للـ resolver",
      "adminKit.resolvedPlanTitle": "خطة محلولة (دمج كتالوج)",
      "adminKit.perResourceQuotasTitle": "حصص لكل مورد (محرك usage.js)",
      "adminKit.colAllowedRaw": "مسموح",
      "adminKit.colUsed": "مستخدم",
      "adminKit.colLimit": "حد",
      "adminKit.colRemaining": "متبقي",
      "adminKit.colEngine": "المحرك",
      "adminKit.opsWindowTitle": "النافذة الزمنية",
      "adminKit.opsWindowSub": "تسميات UTC كما أُرسلت للـ API.",
      "adminKit.metricEventCount": "ai_usage_events (عدد)",
      "adminKit.metricUsageUnits": "مجموع وحدات الاستخدام",
      "adminKit.metricGuestEvents": "أحداث مرتبطة بالضيف",
      "adminKit.metricGuestUnits": "وحدات مرتبطة بالضيف",
      "adminKit.opsHealthTotalsTitle": "إجماليات تجميعية",
      "adminKit.opsHeuristicsTitle": "استدلالات (مراقبة)",
      "adminKit.heurAiHealth": "صحة استخدام الذكاء",
      "adminKit.heurOcrLoad": "حمل OCR",
      "adminKit.heurLlmPressure": "ضغط عمليات النموذج",
      "adminKit.heurFailedRatio": "نسبة التحليل الفاشل",
      "adminKit.officePolicyPreviewTitle": "معاينة سياسة المكتب",
      "adminKit.officePolicyPreviewNote": "يظهر عند توفير office_id.",
      "adminKit.topAiUsageTitle": "أعلى استخدام ذكاء حسب النوع",
      "adminKit.guestPressureTitle": "ضغط الضيف (أعلى الدلاء)",
      "adminKit.officeConsumptionTitle": "استهلاك المكاتب (أعلى القيم)",
      "adminKit.colSourceProject": "المشروع المصدر",
      "adminKit.colUsageType": "نوع الاستخدام",
      "adminKit.colUsageSubtype": "النوع الفرعي",
      "adminKit.colEvents": "الأحداث",
      "adminKit.colUnits": "وحدات الاستخدام",
      "adminKit.colGuestBucket": "دلو الضيف",
      "adminKit.colOfficeId": "معرف المكتب",
      "adminKit.colDateFrom": "من",
      "adminKit.colDateTo": "إلى",
      "adminKit.asyncPending": "مهام معلّقة",
      "adminKit.asyncRetryHeavy": "retry_count ≥ 3",
      "adminKit.asyncStuckThreshold": "عتبة التعلّق (دقائق)",
      "adminKit.asyncStuckSample": "عيّنة صفوف المعالجة العالقة",
      "adminKit.colJobStatus": "الحالة",
      "adminKit.colCount": "العدد",
      "adminKit.colJobType": "نوع المهمة",
      "adminKit.colRetries": "إعادة المحاولة",
      "adminKit.colUpdated": "آخر تحديث",
      "adminKit.readinessGridTitle": "تلميحات البيئة",
      "adminKit.readinessGridSub": "وجود منطقي فقط — لا تُعرض أسرار.",
      "adminKit.configured": "مهيأ",
      "adminKit.missing": "غير مهيأ / فارغ",
      "adminKit.flagsDescriptorTitle": "أعلام الفوترة وبيانات الجاهزية",
      "adminKit.flagsDescriptorSub": "تسميات ثابتة من admin-settings-descriptor؛ القيم من system_settings.",
      "adminKit.colFlagKey": "مفتاح العلم",
      "adminKit.colLabel": "وصف العلم",
      "adminKit.colScope": "النطاق",
      "adminKit.colReadiness": "جاهزية الإنفاذ",
      "adminKit.officeRowCount": "عدد الصفوف",

      "adminHub.navCommercialSnapshot": "لقطة تجارية",
      "adminHub.commercialSnapshotTitle": "لقطة تجارية وتشغيلية",
      "adminHub.commercialSnapshotDesc": "إشارات مجمّعة للقراءة فقط من واجهات الأدمن الحالية — تصدير CSV/JSON آمن؛ دون دفع أو فواتير أو إنفاذ قاسٍ.",
      "adminHub.capCommercialSnapshot": "ملخص داخلي في صفحة واحدة (خطط، إنفاذ، ضيف، معاينة Firm، حصة ذكاء، ضغط async، جاهزية).",

      "adminExport.toolbarAria": "أدوات الجدول",
      "adminExport.search": "بحث",
      "adminExport.searchPlaceholder": "بحث في الأعمدة الظاهرة…",
      "adminExport.filter": "تصفية الأعمدة",
      "adminExport.filterAll": "الكل",
      "adminExport.filterActiveLike": "نشط (صف قاعدة)",
      "adminExport.filterInactive": "غير نشط",
      "adminExport.filterCatalogFallback": "احتياط كتالوج",
      "adminExport.exportCsv": "تصدير CSV",
      "adminExport.exportJson": "تصدير JSON",
      "adminExport.resultCount": "{{filtered}} / {{total}} صفًا",
      "adminExport.resultCountSimple": "{{n}} صفًا",
      "adminExport.noResults": "لا توجد صفوف مطابقة — عدّل البحث أو التصفية.",
      "adminExport.copy": "نسخ",
      "adminExport.copyRow": "نسخ الصف",
      "adminExport.copyJson": "نسخ JSON المصفّى",
      "adminExport.compactMode": "جدول مضغوط",
      "adminExport.readinessConfigured": "مضبوط",
      "adminExport.readinessMissing": "غير مضبوط",
      "adminExport.aiPreviewTableTitle": "مقاييس الحصة (قابلة للتصدير)",

      "adminSnapshot.actionsTitle": "تحديث اللقطة",
      "adminSnapshot.actionsSub": "يستدعي واجهات الأدمن الحالية بالتوازي؛ لا يُخزّن شيء على الخادم.",
      "adminSnapshot.summaryTitle": "نظرة سريعة",
      "adminSnapshot.summarySub": "حقول مختارة فقط — التفاصيل في الصفحات والـ JSON.",
      "adminSnapshot.tableTitle": "مفاتيح المقاييس",
      "adminSnapshot.colMetricKey": "المقياس",
      "adminSnapshot.sourcesJson": "وصول النقاط (نعم/لا)",
      "adminSnapshot.promptLoad": "استخدم «تحميل / تحديث» لبناء لقطة من واجهات الأدمن الحية.",
      "adminSnapshot.cardActivePlans": "خطط شبيهة بالنشطة (كتالوج)",
      "adminSnapshot.cardGuestUpload": "رفع مستندات الضيف (سياسة)",
      "adminSnapshot.cardGuestUploadHint": "سياسة المنتج — وليس مفتاح paywall.",
      "adminSnapshot.cardFirmPreview": "معاينة Firm (ضيف / بلا JWT)",
      "adminSnapshot.cardAiPlan": "رمز خطة معاينة الذكاء",
      "adminSnapshot.cardAsyncPending": "مهام async معلّقة (ملخص)",
      "adminSnapshot.cardReadiness": "مفاتيح الجاهزية المضبوطة / الإجمالي",
      "adminSnapshot.cardCommercialSyncFailed24h": "فشل مزامنة المكتب (٢٤ ساعة، أحداث)",
      "adminSnapshot.cardCommercialEventsRecent": "أحداث تجارية أخيرة (مُجلبة)",
      "adminSnapshot.cardCommercialAutomation": "COMMERCIAL_SYNC_AUTOMATION_MODE",
      "adminSnapshot.cardStaleSyncHint": "تلميح مزامنة عملية قديمة / غير ناجحة",
      "adminSnapshot.commercialOrchestrationJson": "تنسيق تجاري (قراءة فقط)",
      "adminSnapshot.commercialEventsSample": "عيّنة أحداث تجارية حديثة",
      "adminSnapshot.shadowReadinessJson": "حزمة جاهزية الظل (Sprint 3.8، قراءة فقط)",
      "adminSnapshot.cardShadowReadiness": "تحميل حزمة جاهزية الظل",
      "adminSnapshot.cardShadowStaleLevel": "مستوى تحذير حوكمة البيانات القديمة",
      "adminSnapshot.cardShadowDlqScenarios": "وصفي سيناريوهات DLQ (عدد)",
      "adminSnapshot.cardShadowWebhookSlots": "فتحات مزوّدي Webhook (مستقبلي)",

      "adminAnalytics.ydimBlurb": "تحليلات الاستخدام والتسويق لمنصة Ydim (قاعدة Ydim).",
      "adminAnalytics.title": "تحليلات منتج Ydim",
      "adminAnalytics.conversionRate": "معدل التحويل (زائر → تسجيل/دخول)",
      "adminAnalytics.newRegistrations30d": "تسجيلات جديدة (٣٠ يومًا)",
      "adminAnalytics.todayVisitors": "زوار اليوم",
      "adminAnalytics.registeredUsers": "المستخدمون المسجّلون (حسابات)",
      "adminAnalytics.guestVisitors": "زائرون ضيوف (مشاهدات صفحات، ضيف)",
      "adminAnalytics.registeredSessions": "جلسات مسجّلة (مشاهدات صفحات، داخل النظام)",
      "adminAnalytics.totalVisitors": "إجمالي الزوار (جلسات مميّزة)",
      "adminAnalytics.totalPageViews": "إجمالي مشاهدات الصفحات",
      "adminAnalytics.pageRefreshes": "تحديثات الصفحات",
      "adminAnalytics.adminVisits": "زيارات لوحة الإدارة",
      "adminAnalytics.adminRefreshes": "تحديثات لوحة الإدارة",
      "adminAnalytics.monthlyVisitors": "الزوار شهريًا",
      "adminAnalytics.dailyVisitors30d": "الزوار اليومي (٣٠ يومًا)",
      "adminAnalytics.devices": "الأجهزة",
      "adminAnalytics.sources": "المصادر",
      "adminAnalytics.topPages": "الصفحات الأكثر زيارة",
      "adminAnalytics.count": "العدد",
      "adminAnalytics.device": "الجهاز",
      "adminAnalytics.source": "المصدر",
      "adminAnalytics.views": "المشاهدات",
      "adminAnalytics.page": "الصفحة",
      "adminAnalytics.recentEvents": "آخر الأحداث",
      "adminAnalytics.importantClicks": "النقرات المهمة",
      "adminAnalytics.loading": "جاري تحميل التحليلات...",
      "adminAnalytics.failed": "تعذر تحميل التحليلات",
      "adminAnalytics.noData": "لا توجد بيانات",
      "adminAnalytics.desktop": "سطح مكتب",
      "adminAnalytics.mobile": "جوال",
      "adminAnalytics.tablet": "لوحي",
      "adminAnalytics.direct": "مباشر",
      "adminAnalytics.external": "خارجي",
      "adminAnalytics.google": "Google",
      "adminAnalytics.linkedin": "LinkedIn",
      "adminAnalytics.x": "X",
      "adminAnalytics.time": "الوقت",
      "adminAnalytics.type": "النوع",
      "adminAnalytics.event": "الحدث",
      "adminAnalytics.guest": "ضيف",
      "adminAnalytics.session": "الجلسة",
      "adminAnalytics.yes": "نعم",
      "adminAnalytics.no": "لا",
      "adminAnalytics.unknown": "غير معروف",
      "adminAnalytics.dash": "—",
      "adminAnalytics.legalIntelligenceTitle": "تحليلات محرك الذكاء القانوني",
      "adminAnalytics.legalIntelligenceBlurb": "استخدام محرك الذكاء القانوني (قاعدة legal_intelligence؛ ملخص للقراءة فقط).",
      "adminAnalytics.legalIntelligenceUnavailable": "تحليلات محرك الذكاء القانوني غير متاحة",
      "adminAnalytics.legalRegisteredUsers": "المستخدمون المسجّلون",
      "adminAnalytics.legalGuests": "الضيوف",
      "adminAnalytics.legalAnalyses": "التحليلات",
      "adminAnalytics.legalVisitors": "الزوار",
      "adminAnalytics.legalRecentActivity": "النشاط الأخير",
      "adminAnalytics.legalDay": "اليوم",
      "adminAnalytics.legalCount": "العدد",
      "ingestionAnalytics.title": "إحصائيات Ingestion",
      "ingestionAnalytics.unavailable": "إحصائيات Ingestion غير متاحة",
      "ingestionAnalytics.loading": "جارٍ تحميل إحصائيات Ingestion...",
      "ingestionAnalytics.totalVisits": "إجمالي الزيارات",
      "ingestionAnalytics.todayVisitors": "زوار اليوم",
      "ingestionAnalytics.pageViews": "مشاهدات الصفحات",
      "ingestionAnalytics.pageRefreshes": "تحديثات الصفحات",
      "ingestionAnalytics.topPages": "الصفحات الأكثر زيارة",
      "ingestionAnalytics.devices": "الأجهزة",
      "ingestionAnalytics.sources": "مصادر الزيارة",
      "ingestionAnalytics.count": "العدد",
      "ingestionAnalytics.page": "الصفحة",
      "ingestionAnalytics.device": "الجهاز",
      "ingestionAnalytics.source": "المصدر",
      "ingestionAnalytics.views": "المشاهدات",
      "ingestionAnalytics.noData": "لا توجد بيانات",
      "ingestionAnalytics.sectionDesc": "زيارات بوابة Ingestion (قاعدة بيانات منفصلة؛ ملخص للقراءة فقط)."
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ar", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
